<template>
  <div>
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <onaydialog ref="onaydialog"></onaydialog>

    <tahsilatdialog1 ref="tahsilatdialog1" v-model="BiletAyrintiliOdeme"></tahsilatdialog1>
    <v-form>
      <v-card flat="">
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>Faturalı Bilet Düzenle </v-toolbar-title>
              <v-spacer></v-spacer>


              <v-tooltip bottom>
                <v-btn slot="activator" @click="biletkaydet()" flat>
                  <span class="hidden-sm-and-down"> {{ $t('Edit') }}
                  </span>
                  <v-icon right dark>edit</v-icon>
                </v-btn>
                <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Save">Bileti Düzenle</span>
              </v-tooltip>



            </v-toolbar>
          </v-flex>


          <v-layout row="" style="padding-top:10px;" wrap="">
            <v-flex xs12 sm12 md4 style="padding-right:10px;">
              <v-layout column>


                <v-flex xs12 sm6 md12 style=" padding-bottom:10px;">
                  <v-card class="white--text">
                    <v-card flat="">
                      <v-card-actions>
                        <v-layout row wrap>
                          <v-flex xs12 sm12 md12>
                            <musteribilgipart :yolcuadi="yolcudisabled" v-model="Bilet.GenelBilgileri">
                            </musteribilgipart>
                          </v-flex>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm6 md12 style=" padding-bottom:10px;">
                  <v-card class="white--text">
                    <v-card flat="">
                      <v-card-actions>
                        <v-layout row wrap>



                          <v-flex xs12 sm12 md12>
                            <v-layout justify-space-between column>
                              <tarihim :etiket="$t('Date-of-Departure')" :tabindex="'17'"
                                v-bind:value="Bilet.UcusBilgileri.UcusTarihi" v-model="Bilet.UcusBilgileri.UcusTarihi">
                              </tarihim>

                              <v-layout>
                                <v-text-field hide-details="" :tabindex="'18'" v-model="Bilet.UcusBilgileri.UcusNo1"
                                  :label="$t('Departure-Flight-No')" maxlength="3"></v-text-field>
                                <v-text-field hide-details="" tabindex="19" maxlength="4" v-model="Bilet.UcusBilgileri.UcusNo2"
                                  :label="$t('Departure-Flight-No')"></v-text-field>
                              </v-layout>
                              <tarihim :etiket="$t('Date-of-Return')" :tabindex="'20'"
                                v-bind:value="Bilet.UcusBilgileri.UcusDonusTarihi"
                                v-model="Bilet.UcusBilgileri.UcusDonusTarihi"></tarihim>
                              <v-layout>
                                <v-text-field hide-details="" maxlength="3" tabindex=21 v-model="Bilet.UcusBilgileri.UcusDonusNo1"
                                  :label="$t('Return-Flight-No')"></v-text-field>
                                <v-text-field hide-details="" tabindex="22" maxlength="4" v-model="Bilet.UcusBilgileri.UcusDonusNo2"
                                  :label="$t('Return-Flight-No')"></v-text-field>
                              </v-layout>
                              <tarihim :etiket="$t('Reservation-Date')" :tabindex="'23'"
                                v-bind:value="Bilet.NotlarBilgileri.DateofRes"
                                v-model="Bilet.NotlarBilgileri.DateofRes"></tarihim>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

              </v-layout>
            </v-flex>

            <v-flex xs12 sm6 md4 style=" padding-bottom:10px; padding-right:10px;">
              <v-card class="white--text">
                <v-layout>
                  <v-card flat="">
                    <v-card-actions>
                      <v-layout row wrap>
                        <v-flex xs12 sm6 md6>
                          <tarihim :etiket="$t('Buying-Invoice-Date')" v-bind:defaultvalue="'no'"
                            v-bind:value="Bilet.FaturaBilgileri.AlisFaturaTarihi"
                            v-model="Bilet.FaturaBilgileri.AlisFaturaTarihi"></tarihim>
                        </v-flex>
                        <v-flex xs12 sm6 md6>
                          <v-text-field hide-details="" :label="$t('Buying-Invoice-No')"
                            v-model="Bilet.FaturaBilgileri.AlisFaturaNo" maxlength="10" mask="##########"></v-text-field>
                        </v-flex>
                        <v-layout row="" wrap="">
                          <v-flex xs12 sm6 md6>
                            <parainput :isPositive="true" :etiket="$t('Purchase-Service')" :simge="getparabirimi()"
                              v-model="Bilet.OdemeBilgileri.AlisServisTutar.AlisServisTutar"
                              :autocomplete="'autocomplete'"></parainput>
                          </v-flex>
                          <v-flex xs12 sm6 md6>
                            <doviztutarcomp :isPositive="true" :etiket="$t('Purchasing-Service-Currency')"
                              v-model="Bilet.OdemeBilgileri.AlisServisTutar.AlisServisDoviz"
                              :autocomplete="'autocomplete'"></doviztutarcomp>
                          </v-flex>

                        </v-layout>
                        <v-flex xs12 sm12 md12>

                          <kesenkisi v-bind:etiket="$t('Ticket-Agent')" v-model="Bilet.GenelBilgileri.KesenKisi">
                          </kesenkisi>
                        </v-flex>


                        <v-text-field hide-details="" tabindex="27" v-model="Bilet.GenelBilgileri.PnrNo" label="PNR">
                        </v-text-field>
                        <v-text-field hide-details="" tabindex="28" v-model="Bilet.DigerBilgileri.PinKodu"
                          label="PIN Code"></v-text-field>
                        <v-select hide-details="" :items="biletyon" tabindex="29"
                          v-model="Bilet.GenelBilgileri.BiletYon" clearable item-text="text" item-value="value"
                          label="Yön"></v-select>
                        <v-select hide-details="" :items="classtip" tabindex="30"
                          v-model="Bilet.GenelBilgileri.ClassTip" clearable item-text="text" item-value="value"
                          label="Class Tip"></v-select>

                        <v-select :items="fiyatturu" tabindex="32" hide-details="" clearable item-text="text"
                          item-value="value" v-model="Bilet.GenelBilgileri.FiyatTur" :label="$t('Price-Type')"></v-select>
                        <v-text-field hide-details="" tabindex="33" v-model="Bilet.GenelBilgileri.DepartmanKod"
                          :label="$t('Depart-No')"></v-text-field>
                        <v-select :items="crskodu" hide-details="" tabindex="34" v-model="Bilet.GenelBilgileri.Crs"
                          clearable item-text="text" item-value="value" label="CRS"></v-select>
                        <v-text-field tabindex="35" v-model="Bilet.GenelBilgileri.ExBiletNo" hide-details=""
                          label="ECH Bilet No"></v-text-field>
                        <v-flex xs12 sm12 md12>
                          <masrafmerkezicomp :tabdeger="'36'" v-model="Bilet.GenelBilgileri.Masraf.Code">
                          </masrafmerkezicomp>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <referansmerkezicomp :coper="false" :tabdeger="'37'" v-model="Bilet.GenelBilgileri.Referans.Kod">
                          </referansmerkezicomp>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <bolumcomp :tabdeger="'38'" v-model="Bilet.TanimBilgileri.Bolum"></bolumcomp>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-text-field hide-details="" mask="################" v-model="Bilet.NotlarBilgileri.KarbonSalinimi"
                                   :label="$t('Carbon-Emission')"></v-text-field>
                        </v-flex>
                
                      </v-layout>
                    </v-card-actions>
                  </v-card>
                </v-layout>
              </v-card>
            </v-flex>




            <v-flex xs12 sm12 md4>
              <v-flex xs12 sm12 md12>
                <v-card class="white--text">
                  <v-card flat="">
                    <v-card-actions>
                      <v-layout row wrap>
                        <v-flex xs12 sm12 md12>
                          <v-select hide-details="" tabindex="62" v-model="Bilet.OdemeBilgileri.SatisSekli"
                            :items="satissekliitem" item-text="text" item-value="value" clearable :label="$t('Sales-Method')">
                          </v-select>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <tarihim :etiket="$t('Payment-Date')" v-bind:aktifmi="Bilet.OdemeBilgileri.SatisSekli=='C'"
                            v-bind:defaultvalue="'ok'" :tabindex="'63'" v-bind:value="Bilet.TarihBilgileri.OdemeTarihi"
                            v-model="Bilet.TarihBilgileri.OdemeTarihi"></tarihim>
                        </v-flex>
                        <v-layout row wrap v-show="bankaposshow">
                          <v-flex xs12 sm12 md6>
                            <v-autocomplete :items="bankapositems" tabindex="64" hide-details=""
                              v-model="Bilet.OdemeBilgileri.BankaBilgileri.PosKod.PosKodu"
                              @change="taksitgetir(Bilet.OdemeBilgileri.BankaBilgileri.PosKod.PosKodu)"
                              item-text="Title" item-value="PosKodu" clearable :label="$t('Pos-Code')"></v-autocomplete>
                          </v-flex>
                          <v-flex xs12 sm12 md6>
                            <v-select :items="taksitsayi" hide-details="" tabindex="65"
                              v-model="Bilet.OdemeBilgileri.BankaBilgileri.TaksitKod" item-text="TaksitAciklama"
                              item-value="TaksitAdet" clearable :label="$t('Instalment')"></v-select>
                          </v-flex>
                        </v-layout>
                        <v-flex v-if="bankaposshow" xs12 sm12 md12>

                          <parainput :isPositive="true" :etiket="$t('Score-Amount')" :tabdeger="'66'" :simge="getparabirimi()"
                            v-model="Bilet.OdemeBilgileri.BankaBilgileri.PuanTutar" :autocomplete="'autocomplete'">
                          </parainput>
                        </v-flex>
                        <v-layout row wrap v-show="servisposshow">
                          <v-flex xs12 sm12 md6>

                            <v-autocomplete :items="bankapositems" tabindex="67" hide-details=""
                              @change="taksitgetirservis(Bilet.OdemeBilgileri.BankaBilgileri.ServisPosKod.PosKodu)"
                              v-model="Bilet.OdemeBilgileri.BankaBilgileri.ServisPosKod.PosKodu" item-text="Title"
                              item-value="PosKodu" clearable :label="$t('Service-POS-Code')">
                            </v-autocomplete>
                          </v-flex>
                          <v-flex xs12 sm12 md6>
                            <v-select :items="taksitsayiservis" hide-details="" tabindex="68"
                              v-model="Bilet.OdemeBilgileri.BankaBilgileri.ServisTaksitKod" item-text="TaksitAciklama"
                              item-value="TaksitAdet" clearable :label="$t('Instalment')">
                            </v-select>
                          </v-flex>
                        </v-layout>
                        <v-flex v-if="servisposshow" xs12 sm12 md12>

                          <parainput :isPositive="true" :etiket="$t('Service-Pos-Amount')" :tabdeger="69" :simge="getparabirimi()"
                            v-model="Bilet.OdemeBilgileri.BankaBilgileri.ServisPosTutar" :autocomplete="'autocomplete'">
                          </parainput>
                        </v-flex>


                        <v-text-field v-show="makbuznoshow" tabindex="70" v-model="Bilet.OdemeBilgileri.MakbuzNo"
                          hide-details="" :label="$t('Receipt-No')"></v-text-field>
                        <v-text-field v-show="slipnoshow" :label="$t('Slip-No')" tabindex="71"
                          v-model="Bilet.OdemeBilgileri.Slipkod" hide-details=""></v-text-field>

                        <v-flex xs12 v-show="kredikartishow" sm12 md12>
                          <kredikartcomp :tabdeger="'72'" v-model="Bilet.OdemeBilgileri.KrediKartBilgi.KrediKartNo">
                          </kredikartcomp>
                        </v-flex>

                        <v-layout row wrap>
                          <v-flex xs12 sm6 md6>
                            <yuzdeinput :isPositive="true" :etiket="'H.Y. %'" :tabdeger="73" v-model="Bilet.OdemeBilgileri.HYOran"
                              :autocomplete="'autocomplete'"></yuzdeinput>
                          </v-flex>
                          <v-flex xs12 sm6 md6>
                            <parainput :isPositive="true" :etiket="'H.Y. Tutar'" :tabdeger="74" :simge="getparabirimi()"
                              v-model="Bilet.OdemeBilgileri.HavaYoluTutar" :autocomplete="'autocomplete'">
                            </parainput>
                          </v-flex>
                        </v-layout>
                        <v-flex xs12 sm12 md12>

                          <analizcomp :tabdeger="'75'" :etiket="$t('Analysis') + ' 1'"
                            v-model="Bilet.TanimBilgileri.AnalizKod.AnalizKod"></analizcomp>
                        </v-flex>
                        <v-layout>
                          <parainput :isPositive="true" :etiket="$t('Analysis-Amount')" :tabdeger="76" :simge="getparabirimi()" v-model="Bilet.TanimBilgileri.AnalizTutar"
                            :autocomplete="'autocomplete'"></parainput>
                          <parainput :isPositive="true" :etiket="$t('Currency-Amount')" :tabdeger="77" :simge="getparabirimi()" v-model="Bilet.TanimBilgileri.AnalizDoviz"
                            :autocomplete="'autocomplete'"></parainput>
                        </v-layout>
                        <v-flex xs12 sm12 md12>
                          <analizcomp :tabdeger="'78'" :etiket="$t('Analysis') + ' 2'"
                            v-model="Bilet.TanimBilgileri.AnalizKod1.AnalizKod"></analizcomp>
                        </v-flex>
                        <v-layout>

                          <parainput :isPositive="true" :etiket="$t('Analysis-Amount') + ' 2'" :tabdeger="79" :simge="getparabirimi()"
                            v-model="Bilet.TanimBilgileri.AnalizTutar1" :autocomplete="'autocomplete'"></parainput>
                          <parainput :isPositive="true" :etiket="$t('Currency-Amount')" :tabdeger="80" :simge="getparabirimi()" v-model="Bilet.TanimBilgileri.AnalizDoviz1"
                            :autocomplete="'autocomplete'"></parainput>
                        </v-layout>
                      </v-layout>
                    </v-card-actions>
                  </v-card>
                </v-card>
              </v-flex>
            </v-flex>
          </v-layout>


        </v-layout>
      </v-card>
    </v-form>

    <v-dialog v-model="dialogkisamesaj" width="500">

      <v-card>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title class="baslikfont">{{ $t('Warning') }}!</v-toolbar-title>
          </v-toolbar>
        </v-flex>

        <v-card-text>
          {{this.kisamesaj}}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="dialogkisamesaj = false">
            {{$t("cancel_button")}}
          </v-btn>
          <v-btn v-if="btnsilsor" color="primary" flat @click="biletsil()">
            {{ $t('OK') }}
          </v-btn>


        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="loadingdialog" hide-overlay persistent width="400">
      <v-card color="primary" dark>
        <v-card-text>
          {{$t('Processing-please-wait')}} ...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="servisdialog" max-width="500px">
      <v-card color="grey lighten-2">
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title class="baslikfont">{{$t('Service-Code-Selection')}}</v-toolbar-title>
          </v-toolbar>
        </v-flex>
        <v-card-text>
          <v-layout row wrap>
            <div class="flex md12">
              <v-data-table :headers="headersservis" :loading="progress" :items="servisitems" hide-actions
                class="elevation-1">
                <template slot="items" slot-scope="props">
                  <tr @click="servissec(props.item)" item>
                    <td class="text-xs-left">{{ props.item.Kod }}</td>
                    <td class="text-xs-left">{{ props.item.Aciklama }}</td>
                    <td class="text-xs-left">{{ props.item.Tutar }}</td>
                    <td class="text-xs-left">{{ props.item.DovizKod}}</td>
                    <td class="justify-center layout px-0">
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </div>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>

    <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
          :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
        </v-snackbar>
      </v-card>
    </template>
  </div>
</template>
<script>
  import auth from '../../../api/auth'
  import parainput from '../customcomp/parainput'
  import yuzdeinput from '../customcomp/yuzdeinput'
  import dovizinput from '../customcomp/dovizinput'
  import kesenkisi from '../customcomp/kesenkisi'
  import tarihim from '../customcomp/tarihim'
  import ucusdetay from "@/components/app/bilet/partpage/ucusdetay.vue"
  import notlar from "@/components/app/bilet/partpage/notlar.vue"
  import ozelbilgiler from "@/components/app/bilet/partpage/ozelbilgiler.vue"
  import tutarbilgileri from "@/components/app/bilet/partpage/tutarbilgileri.vue"
  import fatura from "@/components/app/bilet/partpage/fatura.vue"
  import tahsilatdialog1 from "@/components/app/bilet/partpage/tahsilatdialog1.vue"
  import yenibiletno from "@/components/app/bilet/partpage/yenibiletdialog1.vue"
  import hykoddegistircomp from "@/components/app/bilet/partpage/hykod.vue"
  import doviztutarcomp from '@/components/app/customcomp/doviztutarcomp.vue'

  import masrafmerkezicomp from "@/components/app/bilet/partpage/masrafmerkezicomp.vue"
  import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"
  import bolumcomp from "@/components/app/bilet/partpage/bolumcomp.vue"
  import parkurcomp from "@/components/app/bilet/partpage/parkurcomp.vue"
  import kredikartcomp from "@/components/app/bilet/partpage/kredikartcomp.vue"
  import analizcomp from "@/components/app/bilet/partpage/analizcomp.vue"
  import musteribilgipart from "@/components/app/bilet/partpage/musteribilgipart.vue"
  import logoo from '../../../assets/control'
  import reportbrosablon from "@/components/app/coper/comp/reportbrosablon.vue";
  import helpers from "@/components/app/customcomp/helpers.js"


  import duzyaziinput from '@/components/app/customcomp/duzyaziinput.vue';
  import moneyinput from '@/components/app/customcomp/moneyinput.vue';
  import sayiinput from '@/components/app/customcomp/sayiinput.vue';
  import tarihinput from '@/components/app/customcomp/tarihim.vue';
  import caricomp from '@/components/app/customcomp/caricomp.vue'
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import onaydialog from "@/components/app/customcomp/onaydialog.vue"


  import Vue from 'vue';

  export default {
    data() {
      return {
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        dialogtahsilatdagit: false,
        miniTutar: {
          Kredili: 0,
          Pesin: 0,
          KrediKartli: 0,
          KrediliDoviz: 0,
          PesinDoviz: 0,
          KrediKartliDoviz: 0
        },
        tahsilatBakiye: 0,
        ucussayi: null,
        caricompitems: null,
        yenibbiletMetin: 'Yeni Bilet',
        btnsilsor: false,
        tabviewozel: false,
        tabviewgenel: true,
        tabviewiade: false,
        tabviewucusdetay: false,
        tabviewtutardetay: false,
        tabviewtahsilat: false,
        tabviewodeme: false,
        tabviewnotlar: false,
        bekletme: false,
        ReserveTutarLabel: null,
        objeler: [],
        biletcoklumu: false,
        yolcudisabled: false,
        toplubilet: [],
        cokluyolcudialog: false,
        eFaturaBilgi: null,
        vmodelhyKod: {
          HavaYoluKodu: null,
          Formno: null,
          AcenteKodu: null,
          Acente: null,
          UcusTipi: null
        },

        headers: [{
            text: this.$t('Payment-Date'),
            value: 'Tarih'
          },
          {
            text: this.$t('Document-Type'),
            value: 'Evrak.Evrakkod',

          },
          {
            text: this.$t('Document-No'),
            value: 'Evrakno'
          },
          {
            text: this.$t('Description'),
            value: 'Aciklama',
          },
          {
            text: this.$t('Amount'),
            value: 'Tutar',
            align: 'right'
          },
          {
            text: this.$t('Currency-Type'),
            value: 'DovizCinsi',
            align: 'center'
          },
          {
            text: this.$t('Currency-Amount'),
            value: 'DovizTutar',
            align: 'right'

          },
          {
            text: this.$t('Pos-Code'),
            value: 'PosKod',
            align: 'center'
          }

        ],

        headersservis: [{
            text: this.$t('Code'),
            value: 'Kod'
          },
          {
            text: this.$t('Description'),
            value: 'Aciklama',

          },
          {
            text: this.$t('Amount'),
            value: 'Tutar'
          },
          {
            text: this.$t('Currency'),
            value: 'DovizKod',
          }
        ],
        headeriade: [{
            text: this.$t('Refund-Date'),
            value: 'TarihBilgileri.IadeTarihi'
          },
          {
            text: this.$t('Ticket-No'),
            value: 'GenelBilgileri.BiletNo',
          },
          {
            text: this.$t('Airline-Code'),
            value: 'GenelBilgileri.HavaYoluKodu',

          },
          {
            text: this.$t('Net-Amount'),
            value: 'TutarBilgileri.NetTutar.NetTutar',
          },

          {
            text: this.$t('Form-No'),
            value: 'GenelBilgileri.Formno'
          }, ,
          {
            text: this.$t('Item-No'),
            value: 'GenelBilgileri.Sirano'
          },

        ],

        havayoluislemtip: true,
        KrediLimiti: 0,
        RezTutarEtiket: null,
        denemedeger: "0001-01-01T00:00:00",
        Bilet: {
          isChange:true,
          GenelBilgileri: {
            ArkmanUsers: '',
            SirketKodu: '',
            BiletNo: '',
            Formno: '',
            HavaYoluKodu: null,
            UcusTipi: '',
            SiparisNo: 0,
            MusteriKodu: {
              Kod: '',
              Uyari: '',
              BilgiNotu: ''
            },
            KesenKisi: '',
            YolcuAdi: '',
            Parkurlar: {
              Parkur1: '',
              Parkur2: '',
              Parkur3: '',
              Parkur4: '',
              Parkur5: '',
            },
            Classlar: {
              Class1: '',
              Class2: '',
              Class3: '',
              Class4: '',
              Class5: '',
            },
            FiyatTur: 'AD', //enum deger
            Referans: {
              Kod: ''
            },
            YolcuAdet: 1,
            Baglantili: false,
            PnrNo: '',
            RezervasyonVeren: '',
            RezervasyonAlan: '',
            Status: null, //enum
            Acente: '',
            AcenteKodu: '',
            ExBiletNo: '',
            ExBiletHY: '',
            ClassTip: 'E', //enum
            BiletYon: 'T', //enum
            DepartmanKod: '',
            Crs: 'Manuel', //enum
            Masraf: {
              Code: ''
            },
            Email: '',
            BiletTel: '',
          },
          TarihBilgileri: {
            KesimTarihi: null,
            SatisTarihi: null,
            IptalTarihi: null,
            IadeTarihi: null,
            OdemeTarihi: null,
          },
          UcusBilgileri: {
            UcusTarihi: null,
            UcusNo1: null,
            UcusNo2: null,
            UcusDonusTarihi: null,
            UcusDonusNo1: null,
            UcusDonusNo2: null,
            UcusListesi: []
          },
          FaturaBilgileri: {
            FaturaTarihi: null,
            FaturaSeri: null,
            FaturaNo: 0,
            EfaturaBilgileri: {
              FaturaNo: null,
              Guid: null,
              FaturaDurumu: null,
              SanalFaturaNo: null,
              GercekFaturaNo: null,
              BasimTarihi: null,
              Kullanici: null,
              GonderimSekli: 0,
              InternetSatis: 0,
              WebAdresi: null,
              OdemeSekli: 0,
              OdemeSekliAciklama: null,
              OdemeAraci: null,
              OdemeTarihi: null
            },
            AlisFaturaNo: null,
            ProformaSeri: null,
            ProformaNo: 0,
            ProformaTarihi: null,
            SatisFaturaID: null,
            MaliyetFaturaID: null,
            AlisFaturaTarihi: null,
            AlisFatNo: null,
            FaturaOtomatik: 0,
            IstinaKod: null,
            KdvKod: null,
          },
          TutarBilgileri: {
            Doviz: {
              DovizKod: ''
            },
            Kur: 1,
            NetTutar: {
              NetTutar: 0,
              NetTutarSatisDoviz: 0,
              NetTutarAlisDoviz: 0,
              NetTutarKdv: 0,
            },
            Tutar: {
              Tutar: 0,
              TutarSatisDoviz: 0,
              TutarAlisDoviz: 0,
              TutarKdv: 0,
            },
            PtaTutar: {
              PtaTutar: 0,
              PtaSatisDoviz: 0,
              PtaAlisDoviz: 0,
              PtaKdv: 0
            },
            AlanVergiTutar: {
              AlanVergiTutar: 0,
              AlanVergiSatisDoviz: 0,
              AlanVergiAlisDoviz: 0,
              AlanVergiKdv: 0,
            },
            CharterTutar: {
              CharterTutar: 0,
              CharterSatisDoviz: 0,
              CharterAlisDoviz: 0,
              CharterKdv: 0
            },
            YFFTutar: {
              YFFTutar: 0,
              YFFDoviz: 0,
              YFFKdv: 0
            },
            ServisTutar: {
              ServisTutar: 0,
              ServisDoviz: 0,
              ServisKdv: 0
            },
            DigerServisTutar: {
              DigerServisTutar: 0,
              DigerServisDoviz: 0,
              DigerServisKdv: 0
            },
            IskontoTutar: {
              IskontoYuzde: 0,
              IskontoTutar: 0,
              IskontoDoviz: 0,
              IskontoKdv: 0
            },
            TaxTutar: {
              TaxTutar: 0,
              TaxSatisDoviz: 0,
              TaxAlisDoviz: 0,
              TaxKdv: 0
            },
            CezaTutar: {
              CezaTutar: 0,
              CezaSatisTutar: 0,
              CezaAlisTutar: 0,
              CezaKdv: 0
            },
            KaTutar: {
              KaTutar: 0,
              KaDoviz: 0,
              KaKdv: 0
            },
            ReserveTutar: {
              ReserveYuzde: 0,
              ReserveTutar: 0,
              ReserveDoviz: 0,
              ReserveKdv: 0
            }
          },

          OdemeBilgileri: {
            SatisSekli: 'K', //enum
            KomisyonTip: '', //enum
            HYOran: 0,
            GSAOran: 0,
            KrediliTutar: 0,
            KrediliDoviz: 0,
            PesinTutar: 0,
            PesinDoviz: 0,
            KrediKartTutar: 0,
            KrediKartDoviz: 0,
            KrediKartBilgi: {
              KrediKartNo: '',
              KrediKartAy: '',
              KrediKartYil: '',
              KrediKartCins: '',
              KrediKartTip: ''
            },
            AlisServisTutar: {
              AlisServisTutar: 0,
              AlisServisDoviz: 0,
              AlisServisKdv: 0
            },
            HavaYoluTutar: 0,
            HavaYoluKdv: 0,
            Csc: false,
            BankaBilgileri: {
              PosKod: {
                BankaPosID: 0,
                SirketKodu: 0,
                PosKodu: '',
                Aciklama: '',
                MuhasebeKodlar: {
                  MuhasebeKodu: '',
                  CMuhasebeKodu: '',
                  FDisAktarimCariKodu: '',
                  FDisAktarimMuhKodu: '',
                  CDisAktarimCariKodu: '',
                  CDisAktarimMuhKodu: '',
                  ServisMuhasebeKodu: '',
                  ServisDisAktarimCariKodu: '',
                  ServisDisAktarimMuhKodu: ''
                },
                Parametreler: {
                  ID: 0,
                  Banka: {
                    BankaID: 0,
                    SirketKodu: 0,
                    BankaKod: '',
                    BankaAdi: '',
                    Cari: {
                      Kod: ''
                    },
                    BankaKisaKod: '',
                    Tip: 0
                  },
                  PosMuhKodu: '',
                  PuanCariKodu: '',
                  SozlesmeBaslangic: null,
                  SozlesmeBitis: null,
                  Aktif: '',
                  VadeTip: '',
                  UyelikTutar: 0,
                  UyelikOran: 0,
                  Kota: 0,
                  KotaGun: 0,
                  KotaCezaTutar: 0,
                  KotaCezaOran: 0,
                  VadeSabitGun: 0,
                  VadeFarkSabit: 0,
                  KotaKod: '',
                  TerminalID: '',
                  UyeIsYeriID: '',
                  UserName: '',
                  UserPass: '',
                  PosType: 0,
                  StoreKey: '',
                }
                //public List<BankaPosTaksit> Taksitler { get; set; }
              },
              ServisPosKod: {
                BankaPosID: 0,
                SirketKodu: 0,
                PosKodu: '',
                Aciklama: '',
                MuhasebeKodlar: {
                  MuhasebeKodu: '',
                  CMuhasebeKodu: '',
                  FDisAktarimCariKodu: '',
                  FDisAktarimMuhKodu: '',
                  CDisAktarimCariKodu: '',
                  CDisAktarimMuhKodu: '',
                  ServisMuhasebeKodu: '',
                  ServisDisAktarimCariKodu: '',
                  ServisDisAktarimMuhKodu: ''
                },
                Parametreler: {
                  ID: 0,
                  Banka: {
                    BankaID: 0,
                    SirketKodu: 0,
                    BankaKod: '',
                    BankaAdi: '',
                    Cari: {
                      Kod: ''
                    },
                    BankaKisaKod: '',
                    Tip: 0
                  },
                  PosMuhKodu: '',
                  PuanCariKodu: '',
                  SozlesmeBaslangic: null,
                  SozlesmeBitis: null,
                  Aktif: '',
                  VadeTip: '',
                  UyelikTutar: 0,
                  UyelikOran: 0,
                  Kota: 0,
                  KotaGun: 0,
                  KotaCezaTutar: 0,
                  KotaCezaOran: 0,
                  VadeSabitGun: 0,
                  VadeFarkSabit: 0,
                  KotaKod: '',
                  TerminalID: '',
                  UyeIsYeriID: '',
                  UserName: '',
                  UserPass: '',
                  PosType: 0,
                  StoreKey: '',
                },
                Taksitler: []
              },

              ServisPosTutar: 0,
              TaksitKod: '',
              ServisTaksitKod: '',
              TaksitKodLabel: '',
              ServisTaksitKodLabel: '',
              PuanTutar: 0
            },
            Slipkod: '',
            MakbuzNo: '',
          },
          DigerBilgileri: {
            SaveTime: null,
            Entegre: false,
            BiletTanim: '',
            eservedTutar1: 0,
            ExIcDis: '',
            EntegreTablo: '',
            GrossTutar: 0,
            ExIcDis: '',
            CharterPtaKodu: '',
            pArkmanEntegre: '',
            PinKodu: '',
            RezervasyonID: '',
            SiparisID: '',
            CKLogID: 0,
            ExIcDis: '',
            ParkurTip: '',
            DServisKod1: '',
            DServisKod2: '',
            KKEnt: '',
            SatisSapEntegre: '',
            MaliyetSapEntegre: '',
            KisiID: 0,
            ExIcDis: '',
            // EntegrasyonID: guid değişkeni
            UserID: 0,
            ExIcDis: ''
          },
          TanimBilgileri: {
            ServisKod: '',
            AnalizKod: {
              SirketKodu: 0,
              AnalizKod: '',
              AnalizAdi: '',
              AnalizTutar: 0,
              AnalizOran: 0,
            },
            AnalizTutar: 0,
            AnalizDoviz: 0,
            AnalizKod1: {
              SirketKodu: 0,
              AnalizKod: '',
              AnalizAdi: '',
              AnalizTutar: 0,
              AnalizOran: 0,
            },
            AnalizTutar1: 0,
            AnalizDoviz1: 0,
            TcKimlikNolar: {
              TcNo1: '',
              TcNo2: '',
              TcNo3: '',
              TcNo4: '',
              TcNo5: ''
            },
            Aciklamalar: {
              Aciklama1: '',
              Aciklama2: '',
              Aciklama3: '',
              Aciklama4: '',
              Aciklama5: '',
              Aciklama6: '',
              Aciklama7: '',
            },
            MilKodu: {
              MilKoduOde: '',
              MilKoduYolcu: '',
              MilAdet: 0,
              MilTutar: 0
            },
            MusteriPersonel: {
              PersonelUcan: {
                ID: 0,
                SirketKodu: 0,
                SirketAdi: '',
                MasrafYeri: '',
                SicilNo: '',
                Adi: '',
                Soyadi: '',
                CalismaYeri: '',
                Bolum: '',
                IcSeyahat: '',
                DisSeyahat: '',
                IsAlani: '',
                Siparis: '',
                Cari: {
                  Kod: ''
                },
                KapatAc: false,
                Email: '',
                Tel: ''
              },
              PersonelSponsor: {
                ID: 0,
                SirketKodu: 0,
                SirketAdi: '',
                MasrafYeri: '',
                SicilNo: '',
                Adi: '',
                Soyadi: '',
                CalismaYeri: '',
                Bolum: '',
                IcSeyahat: '',
                DisSeyahat: '',
                IsAlani: '',
                Siparis: '',
                Cari: {
                  Kod: ''
                },
                KapatAc: false,
                Email: '',
                Tel: ''
              }
            },
            YolcuCrm: {
              CrmYolcu: {
                Ref: 0,
                Adi: '',
                Soyadi: '',
                Tel: '',
                Gsm: '',
                Email: '',
                TCKimlikNo: '',
                ID: 0
              },
              CrmRezervasyon: {
                Ref: 0,
                Adi: '',
                Soyadi: '',
                Tel: '',
                Gsm: '',
                Email: '',
                TCKimlikNo: '',
                ID: 0
              }
            },
            ProfilID: 0,
            SablonID: 0,
            Bolum: '',
            EventID: '',
            ExAciklamalar: {
              ID: 0,
              SirketKodu: 0,
              Biletno: '',
              HavayoluKod: '',
              EmployeeId: '',
              DepartmentId: '',
              CostCenter: '',
              ClientId: '',
              DkNumber: '',
              WwId: '',
              BusinessUnit: '',
              CompanyCode: '',
              SiteCode: '',
              PurposeOt: '',
              PcNumber: '',
              NoHotelBc: '',
              TripApprover: ''
            }
          },
          AyrintiOdemeBilgileri: [],
          NotlarBilgileri: {
            SirketKodu: 0,
            BiletNo: '',
            FormNo: '',
            Aciklama1: '',
            Aciklama2: '',
            Segment1: '',
            Segment2: '',
            Segment3: '',
            Segment4: '',
            Segment5: '',
            RefFare: 0,
            LowFare: 0,
            RealCode: '',
            DateofRes: null,
            MarketCode: '',
            TicketSuffix: '',
            VendorNumber: '',
            ReasonCode: '',
            CRSGDS: '',
            SubPruductCode: '',
            TicketTypeInd: false,
            TourCode: '',
            AlternatifTutar1: 0,
            AlternatifTutar2: 0,
            AlternatifTutar3: 0,
            Anlasmali: false,
            Esnek: false,
            KarbonSalinimi: 0,
            Mil1: 0,
            Mil2: 0,
            Mil3: 0,
            Mil4: 0
          },

          TaksitBilgileri: {
            ID: 0,
            SirketKodu: 0,
            BiletNo: '',
            HavaYoluKodu: '',
            MakbuzNo: '',
            CCNo1: '',
            Tip1: '',
            Ay1: 0,
            Yil1: 0,
            Tutar1: 0,
            Iade1: 0,
            Taksit1: 0,
            TVade1: null,
            PosKodu1: '',
            CCNo2: '',
            Tip2: '',
            Ay2: 0,
            Yil2: 0,
            Tutar2: 0,
            Iade2: 0,
            Taksit2: 0,
            TVade2: null,
            PosKodu2: '',
            CCNo3: '',
            Tip3: '',
            Ay3: 0,
            Yil3: 0,
            Tutar3: 0,
            Iade3: 0,
            Taksit3: 0,
            TVade3: null,
            PosKodu3: '',
            CCNo4: '',
            Tip4: '',
            Ay4: 0,
            Yil4: 0,
            Tutar4: 0,
            Iade4: 0,
            Taksit4: 0,
            TVade4: null,
            PosKodu4: '',
            PesinSatisTutari: 0,
            PesinIadeTutari: 0,
            SlipKod1: '',
            SlipKod2: '',
            SlipKod3: '',
            SlipKod4: '',
            OdemeFaturaId: '',
            OdemeSapEntegre: '',
          }
        },

        faturanodisabled: false,
        UcusList: [],

        UcusListesi: {
          Ucus1: {
            Aktarma: false,
            BiletNo: '',
            FareBases: 0,
            Formno: '',
            ID: '',
            Parkur: '',
            ParkurNo: '',
            SirketKodu: '',
            UcusClass: '',
            UcusHY: '',
            UcusNo: '',
            UcusSaat: '',
            UcusTarihi: null,
            VarisSaat: '',
            VarisTarihi: null
          },
          Ucus2: {
            Aktarma: false,
            BiletNo: '',
            FareBases: 0,
            Formno: '',
            ID: '',
            Parkur: '',
            ParkurNo: '',
            SirketKodu: '',
            UcusClass: '',
            UcusHY: '',
            UcusNo: '',
            UcusSaat: '',
            UcusTarihi: null,
            VarisSaat: '',
            VarisTarihi: null
          },
          Ucus3: {
            Aktarma: false,
            BiletNo: '',
            FareBases: 0,
            Formno: '',
            ID: '',
            Parkur: '',
            ParkurNo: '',
            SirketKodu: '',
            UcusClass: '',
            UcusHY: '',
            UcusNo: '',
            UcusSaat: '',
            UcusTarihi: null,
            VarisSaat: '',
            VarisTarihi: null
          },
          Ucus4: {
            Aktarma: false,
            BiletNo: '',
            FareBases: 0,
            Formno: '',
            ID: '',
            Parkur: '',
            ParkurNo: '',
            SirketKodu: '',
            UcusClass: '',
            UcusHY: '',
            UcusNo: '',
            UcusSaat: '',
            UcusTarihi: null,
            VarisSaat: '',
            VarisTarihi: null
          },
          Ucus5: {
            Aktarma: false,
            BiletNo: '',
            FareBases: 0,
            Formno: '',
            ID: '',
            Parkur: '',
            ParkurNo: '',
            SirketKodu: '',
            UcusClass: '',
            UcusHY: '',
            UcusNo: '',
            UcusSaat: '',
            UcusTarihi: null,
            VarisSaat: '',
            VarisTarihi: null
          }
        },

        servisclass: {
          SirketKodu: '',
          Cari: {
            Kod: null
          },
          Parkurlar: {
            Parkur1: '',
            Parkur2: '',
            Parkur3: '',
            Parkur4: '',
            Parkur5: '',
          },
          Hat: '',
          DefaultKontrol: false
        },

        BiletAyrintiliOdeme: {
          SirketKodu: null,
          ID: 0,
          Tarih: getDateNow(),
          EvrakCinsi: null,
          Doviz: null,
          Kur: 0,
          Tutar: 0,
          DovizTutar: 0,
          PosKod: null,
          OdemeKod: 0,
          Nereden: null,
          EvrakNo: null,
          KrediKartNo: null,
          Aciklama: null,
          TaksitKod: null,
          TaksitKodLabel: null,
          PuanTutar: 0,
          BankaKod: null,
          KarsiCari: ' ',
          TanimID: 0,
          BiletNo: null,
          FormNo: null,
          CariKod: null,
          Referans: null,
          Masraf: null,
          Faturano: null,
          FaturaTarih: null,
          FaturaSeri: null
        },

        BiletIade: {
          GenelBilgileri: {
            SirketKodu: '',
            BiletNo: '',
            Formno: '',
            HavaYoluKodu: '',
            Sirano: '',
            UcusTip: '',
            Cari: {
              Kod: ''
            },
            Parkurlar: {
              Parkur1: '',
              Parkur2: '',
              Parkur3: '',
              Parkur4: '',
              Parkur5: ''
            },
            IadeUcusTip: '', //enum
            KesenKisi: '',
            Masraf: {
              Code: ''
            },
            Referans: {
              Kod: ''
            },
            Crs: '', // enum
            Notlar: '',
          },
          TarihBilgileri: {
            IadeTarihi: null,
            VadeTarihi: null,
            IadeFaturaTarihi: null
          },
          FaturaBilgileri: {
            IadeFaturaNo: null,
            DekontNo: null,
            ServisFaturaNo: null,
            IadeFaturaGelenBelgeNo: null
          },
          TutarBilgileri: {
            Doviz: {
              DovizKod: null
            },
            Kur: 0,
            NetTutar: {
              NetTutar: 0,
              NetTutarSatisDoviz: 0,
              NetTutarAlisDoviz: 0,
              NetTutarKdv: 0,
            },
            Tutar: {
              Tutar: 0,
              TutarSatisDoviz: 0,
              TutarAlisDoviz: 0,
              TutarKdv: 0,
            },
            AlanVergiTutar: {
              AlanVergiTutar: 0,
              AlanVergiSatisDoviz: 0,
              AlanVergiAlisDoviz: 0,
              AlanVergiKdv: 0
            },
            TaxTutar: {
              TaxTutar: 0,
              TaxSatisDoviz: 0,
              TaxAlisDoviz: 0,
              TaxKdv: 0
            },
            YffTutar: {
              YFFTutar: 0,
              YFFDoviz: 0,
              YFFKdv: 0
            },
            IskontoTutar: {
              IskontoYuzde: 0,
              IskontoTutar: 0,
              IskontoDoviz: 0,
              IskontoKdv: 0
            },
            CezaTutar: {
              CezaTutar: 0,
              CezaSatisTutar: 0,
              CezaAlisTutar: 0,
              CezaKdv: 0,
            },
            KaTutar: {
              KaTutar: 0,
              KaDoviz: 0,
              KaKdv: 0
            },
            ServisTutar: {
              ServisTutar: 0,
              ServisDoviz: 0,
              ServisKdv: 0
            },
            IadeServisTutar: {
              IadeServisTutar: 0,
              IadeServisDoviz: 0,
              IadeServisKdv: 0
            },
            DigerServisTutar: {
              DigerServisTutar: 0,
              DigerServisDoviz: 0,
              DigerServisKdv: 0
            },
            ReserveTutar: {
              ReserveYuzde: 0,
              ReserveTutar: 0,
              ReserveDoviz: 0,
              ReserveKdv: 0
            }
          },
          OdemeBilgileri: {
            Odeme: false,
            KrediliTutar: 0,
            KrediliDvzTutar: 0,
            PesinTutar: 0,
            PesinDvzTutar: 0,
            KrediKartTutar: 0,
            KrediKartDvzTutar: 0,
            HY: 0,
            GSA: 0,
            HavayoluTutar: 0,
            Analiz: {
              AnalizKod: ''
            },
            AnalizTutar: 0,
            AnalizDvzTutar: 0,
            Analiz1: {
              AnalizKod: ''
            },
            AnalizTutar1: 0,
            AnalizDvzTutar1: 0,
          },
          DigerBilgileri: {
            IadeTanim: null,
            Entegre: null,
            ExIcDis: null,
            CkLogId: null,
            ParkurTip: null,
            KKEnt: null,
            IadeDekontID: null,
            IadeMaliyetDekontID: null,
            IadeSapEntegre: null,
            IadeMaliyetSapEntegre: null,
            // public Guid EntegrasyonID { get; set; }
            ServisFark: false,
            DekontPusula: '', //enum
            AlisEntegre: null,
          }
          //  public LoginInfo LoginBilgileri { get; set; }
        },

        //----------------------------------------------------------------------------------------

        Fatura: {
          SirketKodu: null,
          FaturaTarih: null,
          FaturaSeri: null,
          FaturaNo: null,
          GibSeri: null,
          BiletBilgi: {
            SirketKodu: null,
            BiletNo: null,
            FormNo: null,
            OdemeTarihi: null,
            CariKod: [],
            NetTutar: 0

          },
          EFaturaBilgi: {
            Unvani: null,
            Unvani2: null,
            Adres1: null,
            Adres2: null,
            IlceSehir: null,
            Email: null,
            VergiDairesi: null,
            VergiNo: null,
            TcKimlikNo: null,
            Adi: null,
            Soyadi: null,
            TUnvani: null,
            DigerAdi: null,
            OnAdiEki: null,
          },
          FaturaBilgi: {
            FaturaTip: 'O',
            FaturaID: 2,
            FaturaXSLTID: null,
            FaturaPdfID: 0,
            FaturaDipAciklama: null
          },
          Opsiyonlar: {
            YolcuGosterme: false,
            DovizliFatura: false,
            FaturaDetayBas: false
          },
          EArsivBilgi: {
            GonderimSekli: null,
            InternetSatis: null,
            WebAdresi: null,
            OdemeSekli: null,
            OdemeSekliAciklama: null,
            OdemeAraci: null,
            OdemeTarihi: null,
          },
          DovizBilgi: {
            EDovizTipi: null,
            EKur: 0,
            DDovizTipi: null,
            DKur: 0
          }
        },
        yenidialog: false,
        tabcontroltahsilat: 0,
        tabcontrolodeme: 0,
        tabcontroliade: 0,
        tabcontroltutar: 0,
        tabcontrolsablon: 0,
        search3: '',
        searchcari: '',
        itemsairlinelist: [],
        odemeitems: [],
        tahsilatitems: [],
        analizitems: [],
        itemsparkur: [],
        bankapositems: [],
        classitems: [],
        Referans: [],
        satiritems: [],
        taksitsayi: [],
        odemesekilleri: [],
        dizaynsec: [],
    
        yedeksablonobjeler: [],
        kredikartiitems: [],
        xsltitems: [],
        itemsevraktipi: [],
        defaultvalue: null,
        tahsilatbtn: false,
        iadetab: false,
        postaksitsayi: '',
        servistaksitsayi: '',
        acentabiletimi: false,
        baslik_mesaji: '',
        ucus1: false,
        ucus2: false,
        ucus3: false,
        ucus4: false,
        ucus5: false,
        loadingdialog: false,
        servisdialog: false,
        tahsilatdialog: false,
        voiddialog: false,
        dialog_baslik: '',
        tcdialog: false,
        m: false,
        k: false,
        progress: false,
        drawer: null,
        baslik: '',
        e1: 0,
        Code: '',
        e2: true,
        yok: false,
        statecari: [],
        statecaritahsilat: [],
        servisitems: [],
        search: '',
        search1: '',
        earsivseridurum: null,
        loading: false,
        Uyelik: {
          MusteriInfo: {
            MusteriID: null,
            MusteriKod: null,
          },
          ProgramTip: [],
          UyelikTip: 0,
          UyelikBitis: null,
          KalanKontor: 0,
          UyelikStatus: false
        },

        cmkodu: [
          'C', 'M'
        ],
        doviztipi: [],
        ichattipi: [
          'D', 'D-', 'D+', 'K', 'K-', 'K+', 'U', 'U-', 'U+', 'L', 'L-', 'L+'
        ],
        kodmesajı: null,
        edoviztipishow: false,
        ddoviztipishow: false,
        anasatisislem: '',
        faturadialog: false,
        tahsilatguncellebuton: false,
        kisamesaj: '',
        dialogkisamesaj: false,
        servisposshow: true,
        bankaposshow: true,
        kredikartishow: true,
        slipnoshow: true,
        makbuznoshow: true,
        biletnodisabled: false,
        guncellebuton: false,
        guncellebtngorunum: false,
        voiddurum: false,
        voidiptalbtn: false,
        voidbtn: false,
        iadebtn: false,
        iadeitems: [],
        taksitsayiservis: [],
        taksitsayitahsilat: [],
        itemsbanka: [],
        bolumler: [],
        uyeliktipi: null,
        kalankontor: 0,
        dialoghydegistir: false,
        dictionary: {
          custom: {
            faturaseri: {
              required: () => 'zorunlu alan'
            },
            faturano: {
              required: () => 'zorunlu alan'
            },
            faturatarih: {
              required: () => this.$t('Please-select-a-date')
            },
            faturatagib: {
              required: () => this.$t('Please-select-a-date')
            },
          }
        },
        faturabtn: true,
        ichatmi: false,
        dishatmi: false,
        gibseri: [],
        faturanovarise: false,
        vadegunsayisi: 0,
        artieksi: null,
        StartDate: null,
        EndDate: null,
        kaydetbuton: false,
        datesatistarihi: null,
        date: null,
        menu: false,
        modal: false,
        dateFormatted: '',
        text1: '',
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        carikod: '',
        unvan: '',
        active: '',
        profilislemTipi: null,
        secilenprofilkayit: null,
        secilenprofilkayit1: null,
        yedeksecilenprofilkayit: null,
        tabletumveriler: [],
        tabloalanisimleri: [],
        itemssablon: [],
        itemsprofil: [],
        sablonobjeler: [],
        Sablon: {
          TemplateID: null,
          ProfilID: null,
        },

      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)

      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status != true) {

        this.Bilet.GenelBilgileri.ArkmanUsers = null;

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var params1 = {
          CompanyCode: credentials.SirketKodu
        }

        this.$http.post(auth.API_URL + 'api/TicketDefinitons/ClassList', params1, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.classitems = response.body
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-class'
            this.progress = false
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-class'
            this.progress = false
            this.snackbar = true
          }
        })




        this.$http.post(auth.API_URL + 'api/BankPos/List', params1, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.bankapositems = response.body
          this.progress = false
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-bankpos'
            this.progress = false
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-bankpos'
            this.snackbar = true
            this.progress = false
          }
        })



        if (this.$route.query.isl == 'edit') {

          var biletparams = {
            SirketKodu: credentials.SirketKodu,
            BiletNo: this.$route.query.biletno,
            HavaYoluKodu: this.$route.query.hyolukod,
            UcusTipi: this.$route.query.ucustipi
          }

          this.loadingdialog = true
          this.biletnodisabled = true
          this.kaydetbuton = false
          this.guncellebtngorunum = true


          this.$http.post(auth.API_URL + 'api/Ticket/TicketGet', biletparams, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {

            this.bekletme = true;

            if (response.body.GenelBilgileri.Status == 'S') {
              this.miniTutar.Pesin = response.body.OdemeBilgileri.PesinTutar
              this.miniTutar.KrediKartli = response.body.OdemeBilgileri.KrediKartTutar
              this.miniTutar.Kredili = response.body.OdemeBilgileri.KrediliTutar
              this.miniTutar.PesinDoviz = response.body.OdemeBilgileri.PesinDoviz
              this.miniTutar.KrediKartliDoviz = response.body.OdemeBilgileri.KrediKartDoviz
              this.miniTutar.KrediliDoviz = response.body.OdemeBilgileri.KrediliDoviz
            }

            this.Bilet.GenelBilgileri.Referans.Kod = String(response.body.GenelBilgileri.Referans.Kod)

            if (response.body.GenelBilgileri.MusteriKodu.Kod != null) {
              this.Bilet.GenelBilgileri.MusteriKodu.Kod = response.body.GenelBilgileri.MusteriKodu.Kod
            }



            this.postaksitsayi = response.body.OdemeBilgileri.BankaBilgileri.TaksitKod

            this.servistaksitsayi = response.body.OdemeBilgileri.BankaBilgileri.ServisTaksitKod

            this.Bilet = response.body

            if (this.Bilet.OdemeBilgileri.SatisSekli == 'K') {

              this.bankaposshow = false
              this.servisposshow = false
              this.kredikartishow = false
              this.slipnoshow = false
              this.makbuznoshow = false
            }

            if (this.Bilet.OdemeBilgileri.SatisSekli == 'P') {
              this.servisposshow = false
              this.bankaposshow = false
              this.kredikartishow = false
              this.slipnoshow = false
              this.makbuznoshow = true
            }

            if (this.Bilet.OdemeBilgileri.SatisSekli == 'C') {
              this.servisposshow = false
              this.bankaposshow = true
              this.kredikartishow = true
              this.slipnoshow = true
              this.makbuznoshow = true
            }

            if (this.Bilet.OdemeBilgileri.SatisSekli == 'R') {
              this.servisposshow = true
              this.bankaposshow = true
              this.kredikartishow = true
              this.slipnoshow = true
              this.makbuznoshow = true
            }

            if (this.Bilet.OdemeBilgileri.SatisSekli == 'F') {
              this.servisposshow = true
              this.bankaposshow = true
              this.kredikartishow = true
              this.slipnoshow = true
              this.makbuznoshow = true
            }

            this.UcusList = response.body.UcusBilgileri.UcusListesi

            // fatura no varsa güncellenemez void yapılamaz
            var fatno = response.body.FaturaBilgileri.FaturaNo

            if (fatno != null && fatno != 0) {
              this.guncellebuton = true
              this.faturabtn = true
              this.voiddurum = true
              this.voidbtn = false
              this.iadebnt = false
              this.faturanodisabled = true
            } else {
              this.faturanodisabled = false
              this.guncellebuton = false
              this.voiddurum = false
              this.faturabtn = false
              this.voidbtn = true
              this.iadebtn = true

            }


            if (response.body.FaturaBilgileri.FaturaNo != null && response.body.FaturaBilgileri.FaturaNo != '') {
              this.Fatura.FaturaTarih = response.body.FaturaBilgileri.FaturaTarihi
              this.Fatura.FaturaSeri = response.body.FaturaBilgileri.FaturaSeri
              this.Fatura.FaturaNo = response.body.FaturaBilgileri.FaturaNo
              this.faturanovarise = true
            }

           if(response.body.OdemeBilgileri.BankaBilgileri.PosKod.Taksitler != null){
              this.taksitsayi = response.body.OdemeBilgileri.BankaBilgileri.PosKod.Taksitler
              this.Bilet.OdemeBilgileri.BankaBilgileri.TaksitKod = 0 
            }


            this.loadingdialog = false

          }, (response) => {
            if (response.status === 0) {
              this.loadingdialog = false
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            } else {
              this.loadingdialog = false
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            }
          })

        } else {

        }

      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {
            if (this.prevRoute != null) {
              var url = '#' + this.prevRoute
              window.open(url, '_self')
            } else {
              var url = '#/'
              window.open(url, '_self')
            }
          } else {
          }

        });

      }

    },
    filters: {

      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },
      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }
    },

    methods: {

      getparabirimi() {
        return helpers.getparabirimi()
      },
      tahsilatal() {
        this.miniTutar.Pesin = this.Bilet.OdemeBilgileri.PesinTutar
        this.miniTutar.KrediKartli = this.Bilet.OdemeBilgileri.KrediKartTutar
        this.miniTutar.Kredili = this.Bilet.OdemeBilgileri.KrediliTutar
        this.miniTutar.PesinDoviz = this.Bilet.OdemeBilgileri.PesinDoviz
        this.miniTutar.KrediKartliDoviz = this.Bilet.OdemeBilgileri.KrediKartDoviz
        this.miniTutar.KrediliDoviz = this.Bilet.OdemeBilgileri.KrediliDoviz
      },
      tahsilatAyarla() {

        var top = this.miniTutar.Kredili + this.miniTutar.Pesin + this.miniTutar.KrediKartli
        var topdoviz = this.miniTutar.KrediliDoviz + this.miniTutar.PesinDoviz + this.miniTutar.KrediKartliDoviz

        if (top != 0) {
          if (top == this.Bilet.TutarBilgileri.NetTutar.NetTutar) {
            this.Bilet.OdemeBilgileri.PesinTutar = this.miniTutar.Pesin
            this.Bilet.OdemeBilgileri.KrediKartTutar = this.miniTutar.KrediKartli
            this.Bilet.OdemeBilgileri.KrediliTutar = this.miniTutar.Kredili

            var doviztutar = this.Bilet.TutarBilgileri.NetTutar.NetTutar / this.Bilet.TutarBilgileri.Kur

            this.Bilet.OdemeBilgileri.PesinDoviz = this.miniTutar.PesinDoviz
            this.Bilet.OdemeBilgileri.KrediKartDoviz = this.miniTutar.KrediKartliDoviz
            this.Bilet.OdemeBilgileri.KrediliDoviz = this.miniTutar.KrediliDoviz
            return true

       


          } else {
            this.text1 = this.$t('Total-amount-must-equal-net-amount')
            this.snackbar = true
            return false
          }
        } else {

          if (this.Bilet.TutarBilgileri.Kur == 0 || this.Bilet.TutarBilgileri.Kur == null || this.Bilet.TutarBilgileri
            .Kur == '') {
            this.Bilet.TutarBilgileri.Kur = 1
          }

          if (this.Bilet.OdemeBilgileri.SatisSekli == 'K') {
            this.miniTutar.Kredili = this.Bilet.TutarBilgileri.NetTutar.NetTutar
            this.miniTutar.KrediliDoviz = this.Bilet.TutarBilgileri.NetTutar.NetTutar / this.Bilet.TutarBilgileri.Kur
            this.miniTutar.Pesin = 0
            this.miniTutar.PesinDoviz = 0
            this.miniTutar.KrediKartli = 0
            this.miniTutar.KrediKartliDoviz = 0
          }

          if (this.Bilet.OdemeBilgileri.SatisSekli == 'P') {

            this.miniTutar.Pesin = this.Bilet.TutarBilgileri.NetTutar.NetTutar
            this.miniTutar.PesinDoviz = this.Bilet.TutarBilgileri.NetTutar.NetTutar / this.Bilet.TutarBilgileri.Kur
            this.miniTutar.Kredili = 0
            this.miniTutar.KrediliDoviz = 0
            this.miniTutar.KrediKartli = 0
            this.miniTutar.KrediKartliDoviz = 0
          }

          if (this.Bilet.OdemeBilgileri.SatisSekli != 'K' || this.Bilet.OdemeBilgileri.SatisSekli != 'P') {

            this.miniTutar.KrediKartli = this.Bilet.TutarBilgileri.NetTutar.NetTutar
            this.miniTutar.KrediKartliDoviz = this.Bilet.TutarBilgileri.NetTutar.NetTutar / this.Bilet.TutarBilgileri
              .Kur
            this.miniTutar.Kredili = 0
            this.miniTutar.KrediliDoviz = 0
            this.miniTutar.Pesin = 0
            this.miniTutar.PesinDoviz = 0
          }
          return true

        }


      },
      cariservisgetir() {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        this.servisclass.Cari.Kod = this.Bilet.GenelBilgileri.MusteriKodu.Kod
        this.servisclass.SirketKodu = credentials.SirketKodu
        this.servisclass.Hat = this.Bilet.GenelBilgileri.UcusTipi
        this.servisclass.Parkurlar.Parkur1 = this.Bilet.GenelBilgileri.Parkurlar.Parkur1
        this.servisclass.Parkurlar.Parkur2 = this.Bilet.GenelBilgileri.Parkurlar.Parkur2
        this.servisclass.Parkurlar.Parkur3 = this.Bilet.GenelBilgileri.Parkurlar.Parkur3
        this.servisclass.Parkurlar.Parkur4 = this.Bilet.GenelBilgileri.Parkurlar.Parkur4
        this.servisclass.Parkurlar.Parkur5 = this.Bilet.GenelBilgileri.Parkurlar.Parkur5
        this.servisclass.DefaultKontrol = true

        var params1 = this.servisclass

        this.$http.post(auth.API_URL + 'api/TicketDefinitons/ServiceCodeList', params1, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {



          if (response.body.length != 0) {

            this.Bilet.TanimBilgileri.ServisKod = response.body[0].Kod
            var params = {
              HavayoluKodu: this.Bilet.GenelBilgileri.HavaYoluKodu,
              SirketKodu: credentials.SirketKodu,
              ServisKodBilgi: response.body[0],
              KurTarih: this.Bilet.TarihBilgileri.SatisTarihi,
              TutarBilgi: {
                ServisTutar: this.Bilet.TutarBilgileri.ServisTutar.ServisTutar,
                BiletTutar: this.Bilet.TutarBilgileri.Tutar.Tutar,
                VergiTutar: this.Bilet.TutarBilgileri.PtaTutar.PtaTutar + this.Bilet.TutarBilgileri.AlanVergiTutar
                  .AlanVergitutar +
                  this.Bilet.TutarBilgileri.YFFTutar.YFFTutar // mco + alan + ceza + yff
              }
            }

            this.$http.post(auth.API_URL + 'api/Helpers/GetServiceCodePrice', params, {
             headers: auth.getAuthCompaniesInfo()
            }).then((response) => {

              this.Bilet.TutarBilgileri.IskontoTutar.IskontoTutar = response.body.IskontoTutar
              this.Bilet.TutarBilgileri.ServisTutar.ServisTutar = response.body.ServisTutar
            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable-GetServiceCodePrice'
                this.snackbar = true
              } else {
                this.text1 = 'Service Unavailable-GetServiceCodePrice'
                this.snackbar = true
              }
            })


          } else {

          }


        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })


      },


      tahsilatbakiyeHesapla() {

        this.tahsilatBakiye = this.Bilet.TutarBilgileri.NetTutar.NetTutar

        this.tahsilatitems.forEach(element => {
          this.tahsilatBakiye = this.tahsilatBakiye - element.Tutar
        });



      },

      getImgUrl(img) {
        return logoo.logoControl(img);
      },
      iadeduzenle(k) {
        var url = '#/bilet/biletiade/id?' + 'isl=iadeget&hyolukod=' + k.GenelBilgileri.HavaYoluKodu + '&biletno=' + k
          .GenelBilgileri
          .BiletNo + '&formno=' + k.GenelBilgileri.Formno + '&sirano=' + k.GenelBilgileri.Sirano + '&ucustipi=' + this
          .Bilet
          .GenelBilgileri.UcusTipi
        window.open(url, '_self')
      },


      kurgetirfatura(tarih, kod) {
        var params1 = {
          Tarih: tarih,
          DovizKod: kod,
          DovizAdi: null,
          KurTutar: 0
        }

        if (tarih != null && tarih != '') {

          this.$http.post(auth.API_URL + 'api/Definitions/GetWebRate', params1, {
            headers: auth.getAuthCompaniesInfo()
          }).then((response) => {
            if(response.body == 0.0){
                  this.BiletAyrintiliOdeme.Kur = 1
              }else{
              this.BiletAyrintiliOdeme.Kur = response.body
              }
          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable-Kur Hesapla'
              this.snackbar = true
            } else {
              this.text1 = 'Service Unavailable-Kur Hesapla'
              this.snackbar = true
            }
          })
        }

      },

      sayfakapat() {
        var url1 = '#/bilet/index'
        window.open(url1, '_self')
      },



      servissec(v) {

        var params = {
          ServisKodBilgi: v,
          HavayoluKodu: this.Bilet.GenelBilgileri.HavaYoluKodu,
          KurTarih: this.Bilet.TarihBilgileri.SatisTarihi,
          TutarBilgi: {
            ServisTutar: this.Bilet.TutarBilgileri.ServisTutar.ServisTutar,
            BiletTutar: this.Bilet.TutarBilgileri.Tutar.Tutar,
            VergiTutar: this.Bilet.TutarBilgileri.PtaTutar.PtaTutar + this.Bilet.TutarBilgileri.AlanVergiTutar
              .AlanVergitutar +
              this.Bilet.TutarBilgileri.YFFTutar.YFFTutar // mco + alan + ceza + yff
          }
        }

        this.$http.post(auth.API_URL + 'api/Helpers/GetServiceCodePrice', params, {
          headers: auth.getAuthCompaniesInfo()
        }).then((response) => {

          this.Bilet.TutarBilgileri.IskontoTutar.IskontoTutar = response.body.IskontoTutar
          this.Bilet.TutarBilgileri.ServisTutar.ServisTutar = response.body.ServisTutar
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-GetServiceCodePrice'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-GetServiceCodePrice'
            this.snackbar = true
          }
        })
        this.Bilet.TanimBilgileri.ServisKod = v.Kod
        this.servisdialog = false


      },
      getDateNow: getDateNow,

      tahsilatkaydet: tahsilatkaydet,
      caribilgigetir: caribilgigetir,
      taksitgetir: taksitgetir,
      taksitgetirservis: taksitgetirservis,
      taksitgetirtahsilat: taksitgetirtahsilat,
      biletkaydet: biletkaydet,
      servisgetir: servisgetir,

      tahsilatsil: tahsilatsil,
      tahsilatguncelle: tahsilatguncelle,
      serviscodeControl: serviscodeControl,
      tutarTopla: tutarTopla,
      tutarToplaSatisDoviz: tutarToplaSatisDoviz,
      tutarToplaAlisDoviz: tutarToplaAlisDoviz,
    },
    computed:{
        dizayntipi(){
          return [{
            text: this.$t('Default'),
            value: 'O'
          },
          {
            text: this.$t('Special'),
            value: 'O'
          },
        ]
        },
        dizaynxslt(){
          return [{
          text: 'tek değer',
          value: '0'
        }, ]
        },
        crskodu(){
          return [
            {
                text: 'Manuel',
                value: 'Manuel'
            }, {
                text: '1 - Amadeus ' + this.$t('International-Line'),
                value: 'AmadeusDisHat'
            }, {
                text: '2 - TK ' + this.$t('Domestic-Line'),
                value: 'TkIcHat'
            }, {
                text: '3 - Atlas',
                value: 'Atlas'
            }, {
                text: '4 - Pegasus',
                value: 'Pegasus'
            }, {
                text: '5 - Onur',
                value: 'Onur'
            }, {
                text: '6 - SunExpress',
                value: 'SunExpress'
            }, {
                text: '7 - Galileo ' + this.$t('Domestic-Line'),
                value: 'GalileoIcHat'
            }, {
                text: '8 - Galileo ' + this.$t('International-Line'),
                value: 'GalileoDisHat'
            }, {
                text: '9 - WorldSpan',
                value: 'Worldspan'
            }, {
                text: '10 - BoraJet',
                value: 'BoraJet'
            }, {
                text: '11 - IATI',
                value: 'IATI'
            }, {
                text: '12 - Sabre',
                value: 'Sabre'
            }, {
                text: '13 - Bilet Bank',
                value: 'BiletBank'
            }, {
                text: '14 - Kolay Bilet',
                value: 'KolayBilet'
            },
             {
                text: '15 - Air Arabia',
                value: 'AirArabia'
            },
             {
                text: '16 - Corendon',
                value: 'Corendon'
            },
             {
                text: '17 - Puzzle',
                value: 'Puzzle'
            },
            {
                text:'27 - Turkmenistan Airline',
                value:'TurkmenistanAirline'
            },
            {
                text:'26 - Amadeus Ic Hat',
                value:'AmadeusIcHat'
            }
          ]
        },
        odemesekli1(){
          return [{
            text: this.$t('Credit-Debit-Card'),
            value: '0'
          },
          {
            text: 'EFT-' + this.$t('Transfer-v3'),
            value: '1'
          },
          {
            text: this.$t('Cash-on-delivery'),
            value: '2'
          },
          {
            text: this.$t('Payment-Intermediary'),
            value: '3'
          },
          {
            text: this.$t('Other'),
            value: '4'
          }
        ]
        },
        komisyontip(){
          return [{
          text: 'K-Komisyonlu',
          value: 'K'
        }, {
          text: 'P-Komisyonsuz',
          value: 'N'
        }]
        },
        satissekliitem(){
          return [{
          text: 'K-' + this.$t('With-Credit'),
          value: 'K'
        }, {
          text: 'P-' + this.$t('Cash'),
          value: 'P'
        }, {
          text: this.$t('R-Card'),
          value: 'R'
        }, {
          text: this.$t('C-Card'),
          value: 'C'
        }, {
          text: 'F-Kredi Kartlı',
          value: 'F'
        }]
        },
        fiyatturu(){
          return [{
            text: 'AD-' + this.$t('Adult'),
            value: 'AD'
          },
          {
            text: 'CHD-' + this.$t('Child'),
            value: 'CHD'
          },
          {
            text: 'INF-' + this.$t('Baby'),
            value: 'INF'
          },
          {
            text: 'TUS-' + this.$t('Diplomatic'),
            value: 'TUS'
          },
          {
            text: 'EX',
            value: 'EX'
          },
          {
            text: 'STD-' + this.$t('Student'),
            value: 'STD'
          },
          {
            text: 'SRC-' + this.$t('Elderly'),
            value: 'SRC'
          },
          {
            text: 'MIL-' + this.$t('Soldier'),
            value: 'MIL'
          },
          {
            text: 'YTH-' + this.$t('Young'),
            value: 'YTH'
          }
        ]
        },
        biletyon(){
          return [{
            text: 'T-Tek Yön',
            value: 'T'
          },
          {
            text: 'C-Çift Yön',
            value: 'C'
          },
          {
            text: 'R- Rissue',
            value: 'R'
          }
        ]
        },
        classtip(){
          return [{
            text: 'B-Business',
            value: 'B'
          },
          {
            text: 'C-Premium Economy',
            value: 'C'
          },
          {
            text: 'E-Economy',
            value: 'E'
          },
          {
            text: this.$t('First-Class'),
            value: 'F'
          },
          {
            text: this.$t('Promotion'),
            value: 'P'
          },
          {
            text: 'X-Infant',
            value: 'X'
          }
        ]
        },
        evethayir(){
          return [{
            text: this.$t('Yes'),
            value: 'E'
          },
          {
            text: this.$t('No-v2'),
            value: 'H'
          },
        ]
        },
        ucustipi(){
          return [{
            text: this.$t('Domestic-Line'),
            value: 'I'
          },
          {
            text: this.$t('International-Line'),
            value: 'D'
          },
          {
            text: 'BSP',
            value: 'B'
          }
        ]
        },
        faturatipi(){
          return [{
            text: this.$t('Sales-Invoice'),
            value: 0
          },
          {
            text: this.$t('Return-Invoice'),
            value: 1
          }
        ]
        },
        gonderimsekli(){
        return [{
            text: this.$t('Paper'),
            value: 0
          },
          {
            text: this.$t('Electronic'),
            value: 1
          }
        ]
        },
        odemesekli(){
          return [{
            text: this.$t('Normal-Sales'),
            value: 0
          },
          {
            text: this.$t('Internet-Sales'),
            value: 1
          }
        ]
        },
        musteritipi(){
        return [{
            text: this.$t('Individual'),
            value: 'B'
          },
          {
            text: this.$t('Corporate'),
            value: 'K'
          }
        ]
        },
        efaturatipi(){
          return [{
            text: this.$t('Commercial'),
            value: '0'
          },
          {
            text: this.$t('Basic'),
            value: '1'
          },
          {
            text: this.$t('Export'),
            value: '2'
          }
        ]
        },
        islembilgileri(){
          return [{
            text: this.$t('Hard-Copy-Invoice'),
            value: 'false'
          },
          {
            text: this.$t('Electronic-Invoice'),
            value: 'true'
          }
        ]
        },
    },
    beforeMount: beforeMount,

    components: {
      'parainput': parainput,
      'dovizinput': dovizinput,
      'yuzdeinput': yuzdeinput,
      'ucusdetay': ucusdetay,
      'notlar': notlar,
      'ozelbilgiler': ozelbilgiler,
      'tutarbilgileri': tutarbilgileri,
      'fatura': fatura,
      'tahsilatdialog1': tahsilatdialog1,
      'yenibiletno': yenibiletno,
      'masrafmerkezicomp': masrafmerkezicomp,
      'referansmerkezicomp': referansmerkezicomp,
      'bolumcomp': bolumcomp,
      doviztutarcomp,
      reportbrosablon,
      tarihim,
      parkurcomp,
      kredikartcomp,
      analizcomp,
      musteribilgipart,
      kesenkisi,
      hykoddegistircomp,
      moneyinput,
      duzyaziinput,
      sayiinput,
      tarihinput,
      caricomp,
      yetkidialog,
      onaydialog
    },
    watch: {
      loadingdialog(val) {
        if (!val) return
        setTimeout(() => (this.loadingdialog = val), )
      },
      'Fatura.FaturaSeri': function (valueseri) {
        this.Fatura.FaturaSeri = valueseri.toUpperCase()
      },
      'Bilet.GenelBilgileri.MusteriKodu.Kod': function (valuecari) {
        this.caribilgigetir();
        // if (this.Bilet.TutarBilgileri.ServisTutar.ServisTutar == 0) {
        //   this.cariservisgetir(); Bu kısım faturalı bilet üzerindeki servis tutarında değişiklik yaptığı için kapatıldı
        // }

      },
      'Bilet.TutarBilgileri.Tutar.Tutar': function (value1) {
        this.tutarTopla();
      },
      'miniTutar.PesinDoviz': function (value) {
        this.miniTutar.Pesin = this.Bilet.TutarBilgileri.Kur * value;
      },
      'miniTutar.KrediKartliDoviz': function (value) {
        this.miniTutar.KrediKartli = this.Bilet.TutarBilgileri.Kur * value;
      },
      'miniTutar.KrediliDoviz': function (value) {
        this.miniTutar.Kredili = this.Bilet.TutarBilgileri.Kur * value;
      },
      'miniTutar.Pesin': function (value) {

        this.miniTutar.PesinDoviz = value / this.Bilet.TutarBilgileri.Kur
      },
      'miniTutar.KrediKartli': function (value) {
        this.miniTutar.KrediKartliDoviz = value / this.Bilet.TutarBilgileri.Kur
      },
      'miniTutar.Kredili': function (value) {
        this.miniTutar.KrediliDoviz = value / this.Bilet.TutarBilgileri.Kur
      },

      'Bilet.TutarBilgileri.AlanVergiTutar.AlanVergiTutar': function (value1) {
        this.tutarTopla();
      },

      'Bilet.TutarBilgileri.TaxTutar.TaxTutar': function (value1) {
        this.tutarTopla();
      },

      'Bilet.TutarBilgileri.YFFTutar.YFFTutar': function (value1) {
        this.tutarTopla();
      },

      'Bilet.TutarBilgileri.DigerServisTutar.DigerServisTutar': function (value1) {
        this.tutarTopla();
      },
      'Bilet.TutarBilgileri.PtaTutar.PtaTutar': function (value1) {
        this.tutarTopla();
      },

      'Bilet.TutarBilgileri.CezaTutar.CezaTutar': function (value1) {
        this.tutarTopla();
      },

      'Bilet.TutarBilgileri.ServisTutar.ServisTutar': function (value1) {
        this.tutarTopla();
      },

      'Bilet.TutarBilgileri.ReserveTutar.ReserveTutar': function (value1) {
        this.tutarTopla();
      },

      'Bilet.TutarBilgileri.IskontoTutar.IskontoTutar': function (value1) {
        this.tutarTopla();
      },

      'Bilet.TutarBilgileri.CharterTutar.CharterTutar': function (value1) {
        this.tutarTopla();
      },
      'Bilet.TutarBilgileri.KaTutar.KaTutar': function (value1) {
        this.tutarTopla();
      },
      'Bilet.TutarBilgileri.Tutar.TutarSatisDoviz': function (value1) {
        this.tutarToplaSatisDoviz();
      },
      'Bilet.TutarBilgileri.AlanVergiTutar.AlanVergiSatisDoviz': function (value1) {
        this.tutarToplaSatisDoviz();
      },
      'Bilet.TutarBilgileri.PtaTutar.PtaSatisDoviz': function (value1) {
        this.tutarToplaSatisDoviz();
      },
      'Bilet.TutarBilgileri.TaxTutar.TaxSatisDoviz': function (value1) {
        this.tutarToplaSatisDoviz();
      },
      'Bilet.TutarBilgileri.YFFTutar.YFFDoviz': function (value1) {
        this.tutarToplaSatisDoviz();
      },
      'Bilet.TutarBilgileri.DigerServisTutar.DigerServisDoviz': function (value1) {
        this.tutarToplaSatisDoviz();
      },
      'Bilet.TutarBilgileri.CezaTutar.CezaSatisTutar': function (value1) {
        this.tutarToplaSatisDoviz();
      },
      'Bilet.TutarBilgileri.ServisTutar.ServisDoviz': function (value1) {
        this.tutarToplaSatisDoviz();
      },
      'Bilet.TutarBilgileri.ReserveTutar.ReserveDoviz': function (value1) {
        this.tutarToplaSatisDoviz();
      },
      'Bilet.TutarBilgileri.CharterTutar.CharterSatisDoviz': function (value1) {
        this.tutarToplaSatisDoviz();
      },
      'Bilet.TutarBilgileri.KaTutar.KaDoviz': function (value1) {
        this.tutarToplaSatisDoviz();
      },
      'Bilet.TutarBilgileri.IskontoTutar.IskontoDoviz': function (value1) {
        this.tutarToplaSatisDoviz();
      },

      'Bilet.TutarBilgileri.Tutar.TutarAlisDoviz': function (value1) {
        this.tutarToplaAlisDoviz();
      },
      'Bilet.TutarBilgileri.PtaTutar.PtaAlisDoviz': function (value1) {
        this.tutarToplaAlisDoviz();
      },
      'Bilet.TutarBilgileri.AlanVergiTutar.AlanVergiAlisDoviz': function (value1) {
        this.tutarToplaAlisDoviz();
      },
      'Bilet.TutarBilgileri.CezaTutar.CezaAlisTutar': function (value1) {
        this.tutarToplaAlisDoviz();
      },
      'Bilet.TutarBilgileri.CharterTutar.CharterAlisDoviz': function (value1) {
        this.tutarToplaAlisDoviz();
      },

      'Bilet.TarihBilgileri.SatisTarihi': function (value1) {

        if (this.Bilet.OdemeBilgileri.SatisSekli == 'C' && this.Bilet.TarihBilgileri.OdemeTarihi != null && this.Bilet
          .TarihBilgileri.OdemeTarihi != '') {
          this.Bilet.TarihBilgileri.OdemeTarihi = this.Bilet.TarihBilgileri.SatisTarihi
        }


        if (this.Bilet.OdemeBilgileri.SatisSekli == 'K' || this.Bilet.OdemeBilgileri.SatisSekli == 'F') {
          var credentials = JSON.parse(window.localStorage.getItem('credentials'));

          if (this.Bilet.TarihBilgileri.SatisTarihi != null && this.Bilet.TarihBilgileri.SatisTarihi != '' && this
            .Bilet
            .GenelBilgileri.MusteriKodu.Kod != '' && this.Bilet.GenelBilgileri.MusteriKodu.Kod != null) {
            var paramsgetexpritydate = {
              SatisTarihi: value1,
              UcusTipi: this.Bilet.GenelBilgileri.UcusTipi,
              CariKodu: this.Bilet.GenelBilgileri.MusteriKodu.Kod,
              SirketKodu: credentials.SirketKodu,
            }

            this.$http.post(auth.API_URL + 'api/Helpers/GetExpiryDate', paramsgetexpritydate, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {

              if (String(response.body) != "0001-01-01T00:00:00") {

                this.Bilet.TarihBilgileri.OdemeTarihi = response.body
              }

            })
          }

        }
      },
      'Bilet.GenelBilgileri.UcusTipi': function (value2) {
        if (value2 == 'I') {
          this.ichatmi = true
          this.dishatmi = false
        } else if (value2 == 'D' || value2 == 'B') {
          this.dishatmi = true
          this.ichatmi = false
        }


      },
      'Bilet.OdemeBilgileri.SatisSekli': function (value3) {

        if (this.Bilet.OdemeBilgileri.SatisSekli == 'K') {

          if (this.Bilet.TutarBilgileri.Kur == 0 || this.Bilet.TutarBilgileri.Kur == null || this.Bilet.TutarBilgileri
            .Kur == '') {
            this.Bilet.TutarBilgileri.Kur = 1
          }
          this.miniTutar.Kredili = this.Bilet.TutarBilgileri.NetTutar.NetTutar
          this.miniTutar.KrediliDoviz = this.Bilet.TutarBilgileri.NetTutar.NetTutar / this.Bilet.TutarBilgileri.Kur

          this.miniTutar.Pesin = 0
          this.miniTutar.PesinDoviz = 0
          this.miniTutar.KrediKartli = 0
          this.miniTutar.KrediKartliDoviz = 0


          this.bankaposshow = false
          this.Bilet.OdemeBilgileri.BankaBilgileri.PosKod.PosKodu = null
          this.Bilet.OdemeBilgileri.BankaBilgileri.TaksitKod = null
          this.Bilet.OdemeBilgileri.BankaBilgileri.PuanTutar = 0
          this.taksitsayi = []
          this.servisposshow = false
          this.Bilet.OdemeBilgileri.BankaBilgileri.ServisPosKod.PosKodu = null
          this.Bilet.OdemeBilgileri.BankaBilgileri.ServisTaksitKod = null
          this.Bilet.OdemeBilgileri.BankaBilgileri.ServisPosTutar = 0
          this.taksitsayiservis = []
          this.kredikartishow = false
          this.Bilet.OdemeBilgileri.KrediKartBilgi.KrediKartNo = null

          this.slipnoshow = false
          this.Bilet.OdemeBilgileri.Slipkod = null

          this.makbuznoshow = false
          this.Bilet.OdemeBilgileri.MakbuzNo = null
        }

        if (this.Bilet.OdemeBilgileri.SatisSekli == 'P') {

          if (this.Bilet.TutarBilgileri.Kur == 0 || this.Bilet.TutarBilgileri.Kur == null || this.Bilet.TutarBilgileri
            .Kur == '') {
            this.Bilet.TutarBilgileri.Kur = 1
          }
          this.miniTutar.Pesin = this.Bilet.TutarBilgileri.NetTutar.NetTutar
          this.miniTutar.PesinDoviz = this.Bilet.TutarBilgileri.NetTutar.NetTutar / this.Bilet.TutarBilgileri.Kur

          this.miniTutar.Kredili = 0
          this.miniTutar.KrediliDoviz = 0

          this.miniTutar.KrediKartli = 0
          this.miniTutar.KrediKartliDoviz = 0

          this.servisposshow = false
          this.Bilet.OdemeBilgileri.BankaBilgileri.ServisPosKod.PosKodu = null
          this.Bilet.OdemeBilgileri.BankaBilgileri.ServisTaksitKod = null
          this.Bilet.OdemeBilgileri.BankaBilgileri.ServisPosTutar = 0
          this.taksitsayiservis = []

          this.bankaposshow = false
          this.Bilet.OdemeBilgileri.BankaBilgileri.PosKod.PosKodu = null
          this.Bilet.OdemeBilgileri.BankaBilgileri.TaksitKod = null
          this.Bilet.OdemeBilgileri.BankaBilgileri.PuanTutar = 0
          this.taksitsayi = []


          this.kredikartishow = false
          this.Bilet.OdemeBilgileri.KrediKartBilgi.KrediKartNo = null

          this.slipnoshow = false
          this.Bilet.OdemeBilgileri.Slipkod = null
          this.makbuznoshow = true
        }

        if (this.Bilet.OdemeBilgileri.SatisSekli == 'C') {
          if (this.Bilet.TutarBilgileri.Kur == 0 || this.Bilet.TutarBilgileri.Kur == null || this.Bilet.TutarBilgileri
            .Kur == '') {
            this.Bilet.TutarBilgileri.Kur = 1
          }
          this.miniTutar.KrediKartli = this.Bilet.TutarBilgileri.NetTutar.NetTutar
          this.miniTutar.KrediKartliDoviz = this.Bilet.TutarBilgileri.NetTutar.NetTutar / this.Bilet.TutarBilgileri
            .Kur
          this.miniTutar.Kredili = 0
          this.miniTutar.KrediliDoviz = 0
          this.miniTutar.Pesin = 0
          this.miniTutar.PesinDoviz = 0



          this.servisposshow = false
          this.Bilet.OdemeBilgileri.MakbuzNo = this.Bilet.GenelBilgileri.BiletNo
          this.Bilet.OdemeBilgileri.BankaBilgileri.ServisPosKod.PosKodu = null
          this.Bilet.OdemeBilgileri.BankaBilgileri.ServisTaksitKod = null
          this.Bilet.OdemeBilgileri.BankaBilgileri.ServisPosTutar = 0
          this.taksitsayiservis = []

          this.Bilet.TarihBilgileri.OdemeTarihi = this.Bilet.TarihBilgileri.SatisTarihi

          // burdayım şuanda

          this.bankaposshow = true
          this.kredikartishow = true
          this.slipnoshow = true
          this.makbuznoshow = true
        }

        if (this.Bilet.OdemeBilgileri.SatisSekli == 'R') {

          if (this.Bilet.TutarBilgileri.Kur == 0 || this.Bilet.TutarBilgileri.Kur == null || this.Bilet.TutarBilgileri
            .Kur == '') {
            this.Bilet.TutarBilgileri.Kur = 1
          }
          this.miniTutar.KrediKartli = this.Bilet.TutarBilgileri.NetTutar.NetTutar
          this.miniTutar.KrediKartliDoviz = this.Bilet.TutarBilgileri.NetTutar.NetTutar / this.Bilet.TutarBilgileri
            .Kur
          this.miniTutar.KrediKartli = this.Bilet.TutarBilgileri.NetTutar.NetTutar
          this.miniTutar.KrediKartliDoviz = this.Bilet.TutarBilgileri.NetTutar.NetTutar / this.Bilet.TutarBilgileri
            .Kur
          this.miniTutar.Kredili = 0
          this.miniTutar.KrediliDoviz = 0
          this.miniTutar.Pesin = 0
          this.miniTutar.PesinDoviz = 0


          this.bankaposshow = false
          this.Bilet.OdemeBilgileri.MakbuzNo = this.Bilet.GenelBilgileri.BiletNo
          this.Bilet.OdemeBilgileri.BankaBilgileri.PosKod.PosKodu = null
          this.Bilet.OdemeBilgileri.BankaBilgileri.TaksitKod = null
          this.Bilet.OdemeBilgileri.BankaBilgileri.PuanTutar = 0


          this.servisposshow = true
          this.kredikartishow = true
          this.slipnoshow = true
          this.makbuznoshow = true
        }

        if (this.Bilet.OdemeBilgileri.SatisSekli == 'F') {

          if (this.Bilet.TutarBilgileri.Kur == 0 || this.Bilet.TutarBilgileri.Kur == null || this.Bilet.TutarBilgileri
            .Kur == '') {
            this.Bilet.TutarBilgileri.Kur = 1
          }
          this.miniTutar.KrediKartli = this.Bilet.TutarBilgileri.NetTutar.NetTutar
          this.miniTutar.KrediKartliDoviz = this.Bilet.TutarBilgileri.NetTutar.NetTutar / this.Bilet.TutarBilgileri
            .Kur
          this.miniTutar.KrediKartli = this.Bilet.TutarBilgileri.NetTutar.NetTutar
          this.miniTutar.KrediKartliDoviz = this.Bilet.TutarBilgileri.NetTutar.NetTutar / this.Bilet.TutarBilgileri
            .Kur
          this.miniTutar.Kredili = 0
          this.miniTutar.KrediliDoviz = 0
          this.miniTutar.Pesin = 0
          this.miniTutar.PesinDoviz = 0

          this.servisposshow = true
          this.bankaposshow = true
          this.kredikartishow = true
          this.slipnoshow = true
          this.makbuznoshow = true
        }
      },
    }
  }


  function tutarTopla() {
    this.Bilet.TutarBilgileri.NetTutar.NetTutar =
      (this.Bilet.TutarBilgileri.Tutar.Tutar +
        this.Bilet.TutarBilgileri.PtaTutar.PtaTutar +
        this.Bilet.TutarBilgileri.AlanVergiTutar.AlanVergiTutar +
        this.Bilet.TutarBilgileri.TaxTutar.TaxTutar +
        this.Bilet.TutarBilgileri.YFFTutar.YFFTutar +
        this.Bilet.TutarBilgileri.DigerServisTutar.DigerServisTutar +
        this.Bilet.TutarBilgileri.CezaTutar.CezaTutar +
        this.Bilet.TutarBilgileri.ServisTutar.ServisTutar +
        this.Bilet.TutarBilgileri.ReserveTutar.ReserveTutar +
        this.Bilet.TutarBilgileri.CharterTutar.CharterTutar +
        this.Bilet.TutarBilgileri.KaTutar.KaTutar) -
      this.Bilet.TutarBilgileri.IskontoTutar.IskontoTutar

    this.Bilet.TutarBilgileri.NetTutar.NetTutar = Math.round(this.Bilet.TutarBilgileri.NetTutar.NetTutar * 100) / 100
  }

  function tutarToplaSatisDoviz() {

    this.Bilet.TutarBilgileri.NetTutar.NetTutarSatisDoviz =
      (this.Bilet.TutarBilgileri.Tutar.TutarSatisDoviz +
        this.Bilet.TutarBilgileri.PtaTutar.PtaSatisDoviz +
        this.Bilet.TutarBilgileri.AlanVergiTutar.AlanVergiSatisDoviz +
        this.Bilet.TutarBilgileri.TaxTutar.TaxSatisDoviz +
        this.Bilet.TutarBilgileri.YFFTutar.YFFDoviz +
        this.Bilet.TutarBilgileri.DigerServisTutar.DigerServisDoviz +
        this.Bilet.TutarBilgileri.CezaTutar.CezaSatisTutar +
        this.Bilet.TutarBilgileri.ServisTutar.ServisDoviz +
        this.Bilet.TutarBilgileri.ReserveTutar.ReserveDoviz +
        this.Bilet.TutarBilgileri.CharterTutar.CharterSatisDoviz +
        this.Bilet.TutarBilgileri.KaTutar.KaDoviz) -
      this.Bilet.TutarBilgileri.IskontoTutar.IskontoDoviz

  


  }

  function tutarToplaAlisDoviz() {
    this.Bilet.TutarBilgileri.NetTutar.NetTutarAlisDoviz =
      this.Bilet.TutarBilgileri.Tutar.TutarAlisDoviz +
      this.Bilet.TutarBilgileri.PtaTutar.PtaAlisDoviz +
      this.Bilet.TutarBilgileri.AlanVergiTutar.AlanVergiAlisDoviz +
      this.Bilet.TutarBilgileri.CezaTutar.CezaAlisTutar +
      this.Bilet.TutarBilgileri.CharterTutar.CharterAlisDoviz
  }



  function tahsilatkaydet() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    this.BiletAyrintiliOdeme.CariKod = this.Bilet.GenelBilgileri.MusteriKodu.Kod
    this.BiletAyrintiliOdeme.SirketKodu = credentials.SirketKodu
    this.BiletAyrintiliOdeme.BiletNo = this.Bilet.GenelBilgileri.BiletNo
    this.BiletAyrintiliOdeme.FormNo = this.Bilet.GenelBilgileri.Formno
    this.BiletAyrintiliOdeme.Referans = this.Bilet.GenelBilgileri.Referans.Kod
    this.BiletAyrintiliOdeme.Masraf = this.Bilet.GenelBilgileri.Masraf.Code
    this.BiletAyrintiliOdeme.Faturano = this.Bilet.FaturaBilgileri.FaturaNo
    this.BiletAyrintiliOdeme.FaturaTarih = this.Bilet.FaturaBilgileri.FaturaTarih
    this.BiletAyrintiliOdeme.FaturaSeri = this.Bilet.FaturaBilgileri.FaturaSeri

    var paramstahsilat = this.BiletAyrintiliOdeme
    this.$http.post(auth.API_URL + 'api/Payment/DetailPaymentAdd', paramstahsilat, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.text1 = response.body.ResponseMessage
      this.snackbar = true
      this.tahsilatdialog = false


      var tahsilatparams = {

        SirketKodu: credentials.SirketKodu,
        BiletNo: this.Bilet.GenelBilgileri.BiletNo,
        FormNo: this.Bilet.GenelBilgileri.Formno,
        BA: 1,
        CariKod: this.Bilet.GenelBilgileri.MusteriKodu.Kod
      }

      this.$http.post(auth.API_URL + 'api/CurrentMovement/CurrentTicketList', tahsilatparams, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.tahsilatitems = response.body
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        }
      })



    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = response.body.StatusText
        this.snackbar = true
      }
    })
  }


  function tahsilatsil(deger) {

    if (deger.Nereden != 'C' && deger.Nereden != 'c') {


      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      var paramstahsilat = {
        SirketKodu: credentials.SirketKodu,
        OdemeKod: deger.OdemeKod,
        BiletNo: this.Bilet.GenelBilgileri.BiletNo,
        FormNo: this.Bilet.GenelBilgileri.Formno,
        Nereden: deger.Nereden,
        TanimID: deger.TanimID
      }

      this.$http.post(auth.API_URL + 'api/Payment/DetailPaymentDelete', paramstahsilat, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.text1 = response.body.ResponseMessage
        this.snackbar = true
        this.tahsilatdialog = false



        var tahsilatparams = {

          SirketKodu: credentials.SirketKodu,
          BiletNo: this.Bilet.GenelBilgileri.BiletNo,
          FormNo: this.Bilet.GenelBilgileri.Formno,
          BA: 1,
          CariKod: this.Bilet.GenelBilgileri.MusteriKodu.Kod
        }

        this.$http.post(auth.API_URL + 'api/CurrentMovement/CurrentTicketList', tahsilatparams, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.tahsilatitems = response.body
          this.tahsilatbakiyeHesapla();
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })



      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        } else {
          this.text1 = response.body.StatusText
          this.snackbar = true
        }
      })

    } else {
      this.kisamesaj = this.$t('record-has-received-transaction-cannot-process')
      this.dialogkisamesaj = true
    }
  }



  function tahsilatguncelle(deger) {

    if (deger.Nereden != 'C' && deger.Nereden != 'c') {
      paramstahsilat = this.BiletAyrintiliOdeme

      this.$http.post(auth.API_URL + 'api/Payment/DetailPaymentUpdate', paramstahsilat, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.text1 = response.body.ResponseMessage
        this.snackbar = true
        this.tahsilatdialog = false


        var tahsilatparams = {

          SirketKodu: credentials.SirketKodu,
          BiletNo: this.Bilet.GenelBilgileri.BiletNo,
          FormNo: this.Bilet.GenelBilgileri.Formno,
          BA: 1,
          CariKod: this.Bilet.GenelBilgileri.MusteriKodu.Kod
        }

        this.$http.post(auth.API_URL + 'api/CurrentMovement/CurrentTicketList', tahsilatparams, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.tahsilatitems = response.body
          this.tahsilatbakiyeHesapla();
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })

      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        } else {
          this.text1 = response.body.StatusText
          this.snackbar = true
        }
      })

    } else {
      this.kisamesaj = this.$t('record-has-received-transaction-cannot-process')
      this.dialogkisamesaj = true
    }
  }






  function biletkaydet() {

    if (this.Bilet.GenelBilgileri.MusteriKodu.Kod != null && this.Bilet.GenelBilgileri.MusteriKodu.Kod != '') {

      if (this.Bilet.TarihBilgileri.SatisTarihi != null && this.Bilet.TarihBilgileri.SatisTarihi != '') {

        if (this.Bilet.TarihBilgileri.OdemeTarihi != null && this.Bilet.TarihBilgileri.OdemeTarihi != '') {

          var credentials = JSON.parse(window.localStorage.getItem('credentials'));

          this.Bilet.GenelBilgileri.SirketKodu = credentials.SirketKodu

          //satış şekline göre tutarları yazıyoruz
          if (this.Bilet.OdemeBilgileri.SatisSekli == 'K') {
            this.Bilet.OdemeBilgileri.KrediliTutar = this.Bilet.TutarBilgileri.NetTutar.NetTutar
            this.Bilet.OdemeBilgileri.PesinTutar = 0
            this.Bilet.OdemeBilgileri.KrediKartTutar = 0
            this.Bilet.OdemeBilgileri.KrediKartBilgi.KrediKartTip = null
          } else if (this.Bilet.OdemeBilgileri.SatisSekli == 'P') {
            this.Bilet.OdemeBilgileri.PesinTutar = this.Bilet.TutarBilgileri.NetTutar.NetTutar
            this.Bilet.OdemeBilgileri.KrediliTutar = 0
            this.Bilet.OdemeBilgileri.KrediKartTutar = 0
            this.Bilet.OdemeBilgileri.KrediKartBilgi.KrediKartTip = 'P'

          } else if (this.Bilet.OdemeBilgileri.SatisSekli == 'R' || this.Bilet.OdemeBilgileri.SatisSekli == 'C' ||
            this.Bilet.OdemeBilgileri.SatisSekli == 'F') {

            if (this.Bilet.OdemeBilgileri.SatisSekli == 'R') {
              this.Bilet.OdemeBilgileri.KrediKartBilgi.KrediKartTip = 'R'
            } else if (this.Bilet.OdemeBilgileri.SatisSekli == 'C') {
              this.Bilet.OdemeBilgileri.KrediKartBilgi.KrediKartTip = 'C'
            } else if (this.Bilet.OdemeBilgileri.SatisSekli == 'F') {
              this.Bilet.OdemeBilgileri.KrediKartBilgi.KrediKartTip = 'F'
              //this.Bilet.OdemeBilgileri.SatisSekli = 'F'
            }

            this.Bilet.OdemeBilgileri.KrediKartTutar = this.Bilet.TutarBilgileri.NetTutar.NetTutar
            this.Bilet.OdemeBilgileri.KrediliTutar = 0
            this.Bilet.OdemeBilgileri.PesinTutar = 0
          }


         // var tahsilatdurumu = this.tahsilatAyarla();



            this.Bilet.isChange = true

            var paramsbilet = this.Bilet

            this.$http.post(auth.API_URL + 'api/Ticket/TicketAdd', paramsbilet, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {

              this.text1 = response.body.ResponseMessage
              this.snackbar = true
              if (response.body.Status != Boolean(false)) {
                this.faturabtn = false

                var url = '#/bilet/yeni/id?' + 'isl=get&hyolukod=' + this.Bilet.GenelBilgileri.HavaYoluKodu +
                  '&biletno=' +
                  this.Bilet.GenelBilgileri.BiletNo + '&ucustipi=' + this.Bilet.GenelBilgileri.UcusTipi + '&tab=0'
                window.open(url, '_self')

                setTimeout(function () {
                  window.location.reload(false);
                }.bind(this), 1000)

              }

            }, (response) => {
              this.text1 = response.body.ResponseMessage
              this.snackbar = true

              if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              } else {
                this.text1 = response.body.ResponseMessage
                this.snackbar = true
              }
            })






        } else {
          this.text1 = 'Lütfen ödeme tarihini giriniz'
          this.snackbar = true
        }
      } else {
        this.text1 = 'Lütfen satış tarihini giriniz'
        this.snackbar = true
      }
    } else {
      this.text1 = 'Lütfen bir cari kod seçiniz'
      this.snackbar = true
    }
  }



  function taksitgetirservis(v) {
    var tumliste = []
    tumliste = this.bankapositems

    tumliste.forEach(element => {
      if (element.PosKodu == v) {
        this.taksitsayiservis = []
        this.taksitsayiservis = element.Taksitler
      }
      this.Bilet.OdemeBilgileri.BankaBilgileri.ServisTaksitKod = parseInt(this.servistaksitsayi)
    });
  }

  function taksitgetirtahsilat(v) {

    var tumliste = []
    tumliste = this.bankapositems

    tumliste.forEach(element => {

      if (element.PosKodu == v) {

        this.taksitsayitahsilat = []
        this.taksitsayitahsilat = element.Taksitler
      }


    });
  }

  function taksitgetir(v) {
    var tumliste = []
    tumliste = this.bankapositems

    tumliste.forEach(element => {

      if (element.PosKodu == v) {

        this.taksitsayi = []
        this.taksitsayi = element.Taksitler
      }
    });
    this.Bilet.OdemeBilgileri.BankaBilgileri.TaksitKod = parseInt(this.postaksitsayi)

  }

  function caribilgigetir(a) {


    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    var CurrentInput = {
      Code: this.Bilet.GenelBilgileri.MusteriKodu.Kod,
      CompanyCode: credentials.SirketKodu
    }
    this.$http.post(auth.API_URL + 'api/Current/Get', CurrentInput, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

      this.eFaturaBilgi = response.body.EInvoiceCustomer
      this.Bilet.GenelBilgileri.MusteriKodu.Unvan = response.body.Title
      this.Fatura.EFaturaBilgi.Unvani = response.body.Title
      this.Fatura.EFaturaBilgi.Adres1 = response.body.Invoice.Address
      this.Fatura.EFaturaBilgi.IlceSehir = response.body.Invoice.Province
      this.Fatura.EFaturaBilgi.Email = response.body.Email
      this.Fatura.EFaturaBilgi.VergiDairesi = response.body.Invoice.TaxOffice
      this.Fatura.EFaturaBilgi.VergiNo = response.body.Invoice.TaxNumber
      this.Fatura.EFaturaBilgi.TcKimlikNo = response.body.Invoice.IdentityNumber
      this.Fatura.EFaturaBilgi.Adi = response.body.Invoice.PerFirstName
      this.Fatura.EFaturaBilgi.Soyadi = response.body.Invoice.PerFamilyName
      this.Fatura.EFaturaBilgi.TUnvani = response.body.Invoice.PerTitle
      this.Fatura.EFaturaBilgi.DigerAdi = response.body.Invoice.PerMiddleName
      this.Fatura.EFaturaBilgi.OnAdiEki = response.body.Invoice.PerNameSuffix
      this.Bilet.GenelBilgileri.MusteriKodu.Uyari = response.body.WarningNote
      if (response.body.EArchiveSendType == true) {
        this.Bilet.FaturaBilgileri.EfaturaBilgileri.GonderimSekli = 1;
      } else {
        this.Bilet.FaturaBilgileri.EfaturaBilgileri.GonderimSekli = 0;
      }


      //0 ise Earşiv / 1 ise gib seri

      if (response.body.EInvoiceCustomer == 1) {
        this.earsivseridurum = 1
      }

      if (response.body.EInvoiceCustomer == 0) {
        this.earsivseridurum = 0
      }





      if (this.Bilet.TarihBilgileri.SatisTarihi != null && this.Bilet.TarihBilgileri.SatisTarihi != '' && this
        .Bilet.GenelBilgileri.MusteriKodu.Kod != '' && this.Bilet.GenelBilgileri.MusteriKodu.Kod != null) {

        if (this.Bilet.OdemeBilgileri.SatisSekli == 'K' || this.Bilet.OdemeBilgileri.SatisSekli == 'F') {
          var paramsgetexpritydate = {
            SatisTarihi: this.Bilet.TarihBilgileri.SatisTarihi,
            UcusTipi: this.Bilet.GenelBilgileri.UcusTipi,
            CariKodu: this.Bilet.GenelBilgileri.MusteriKodu.Kod,
            SirketKodu: credentials.SirketKodu,
          }
          this.$http.post(auth.API_URL + 'api/Helpers/GetExpiryDate', paramsgetexpritydate, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {

            if (String(response.body) != "0001-01-01T00:00:00") {
              this.Bilet.TarihBilgileri.OdemeTarihi = response.body
            }

          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            } else {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            }
          })
        }
      }


    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = response.body.StatusText
        this.snackbar = true
      }
    })
  }



  function servisgetir() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    this.servisclass.Cari.Kod = this.Bilet.GenelBilgileri.MusteriKodu.Kod
    this.servisclass.SirketKodu = credentials.SirketKodu
    this.servisclass.Hat = this.Bilet.GenelBilgileri.UcusTipi
    this.servisclass.Parkurlar.Parkur1 = this.Bilet.GenelBilgileri.Parkurlar.Parkur1
    this.servisclass.Parkurlar.Parkur2 = this.Bilet.GenelBilgileri.Parkurlar.Parkur2
    this.servisclass.Parkurlar.Parkur3 = this.Bilet.GenelBilgileri.Parkurlar.Parkur3
    this.servisclass.Parkurlar.Parkur4 = this.Bilet.GenelBilgileri.Parkurlar.Parkur4
    this.servisclass.Parkurlar.Parkur5 = this.Bilet.GenelBilgileri.Parkurlar.Parkur5
    this.servisclass.DefaultKontrol = false

    var params1 = this.servisclass

    this.$http.post(auth.API_URL + 'api/TicketDefinitons/ServiceCodeList', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.servisitems = response.body

    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })
    this.servisdialog = true
  }

  function serviscodeControl() {

    if (this.val != null && this.val != '') {

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
      var params1 = {
        CompanyCode: credentials.SirketKodu,
        Type: 307,
        ID: escape(this.val),
      }

      this.$http.post(auth.API_URL + 'api/Definitions/GeneralTypeGet', params1, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        if (response.body.length == 1) {
          this.val = response.body[0].ID
          this.kodmesajı = null
        } else {
          this.kodmesajı = this.$t('Incorrect-code-entry')
          this.val = null
        }
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable-analizkodu'
          this.snackbar = true
          this.progress = false
        } else {
          this.text1 = 'Service Unavailable-analizkodu'
          this.snackbar = true
          this.progress = false
        }
      })
    } else {
      this.kodmesajı = null
    }
  }

  function beforeMount() {


  }

  function getDateNow() {

    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }

    today = yyyy + '-' + mm + '-' + dd + 'T00:00:00'
    return today
  }
</script>
<style>
  .v-input__icon {
    width: 11px !important;
    min-width: 11px !important;
  }
</style>